/* ARTMIE IE rewriter v1 (from the IT engine) — generated 2026-10-06T11:13:17.820Z — IT engine generated 2026-05-14T19:21:33.106Z */
/*
   Translates SK→EN UI strings client-side for the Ireland market (artmie.com).
   Activates when EITHER:
     - the URL path starts with /en-ie/ (pre-cutover staging via subfolder), OR
     - the hostname matches artmie.it (post-DNS-cutover dedicated domain), OR
     - window.ArtmieIT === true (manual override for testing).

   Loop guard: pairs whose replacement contains the source are filtered out at runtime
   so we never recurse on a partial match.
*/
(function () {
  var __path = (window.location.pathname || '');
  var __host = (window.location.hostname || '');
  var pathMode = /^\/(en-ie)(\/|$)/.test(__path);
  var hostMode = /(^|\.)artmie\.com$/i.test(__host);
  if (!pathMode && !hostMode && window.ArtmieIE !== true) return;

  document.documentElement.classList.add('ie-market');
  document.documentElement.setAttribute('data-ie-market', '1');

  /* FORCE_MARKET — ensure Shopify market context = IT when on subfolder.
     Skipped when on the dedicated domain since Shopify resolves the market by host. */
  function ensureMarket() {
    if (!pathMode) return;
    try {
      if (sessionStorage.getItem('artmie_ie_market_set') === '1') return;
      var formData = new FormData();
      formData.append('form_type', 'localization');
      formData.append('_method', 'PUT');
      formData.append('country_code', 'IE');
      formData.append('language_code', 'en');
      formData.append('return_to', window.location.pathname);
      fetch('/localization', { method: 'POST', body: formData, credentials: 'same-origin' })
        .then(function () { sessionStorage.setItem('artmie_ie_market_set', '1'); })
        .catch(function () {});
    } catch (e) {}
  }
  ensureMarket();

  /* CSS injection — hide app-store links sitewide (no IT app). */
  function injectCss() {
    if (document.getElementById('artmie-ie-injected-css')) return;
    var s = document.createElement('style');
    s.id = 'artmie-ie-injected-css';
    s.textContent = [
      'a[href*="apps.apple.com"]{display:none !important;}',
      'a[href*="itunes.apple.com"]{display:none !important;}',
      'a[href*="play.google.com"]{display:none !important;}',
      'a[href*="app.appsflyer.com"]{display:none !important;}',
      '.artmie-app-link-separator{display:none !important;}'
    ].join('\n');
    (document.head || document.documentElement).appendChild(s);
  }
  injectCss();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', injectCss);

  /* DOM hider — climb from any app-store link to a row container and hide it. */
  function hideAppBlocks() {
    var appLinks = document.querySelectorAll('a[href*="apps.apple.com"],a[href*="itunes.apple.com"],a[href*="play.google.com"],a[href*="app.appsflyer.com"]');
    for (var i = 0; i < appLinks.length; i++) {
      var el = appLinks[i];
      for (var j = 0; j < 6 && el && el.parentElement; j++) {
        el = el.parentElement;
        var tag = el.tagName && el.tagName.toLowerCase();
        var cls = (el.className && el.className.baseVal !== undefined) ? el.className.baseVal : (el.className || '');
        cls = String(cls);
        if (tag === 'li' || /(\brow\b|\bitem\b|\bcard\b|\bblock\b|\bpdp\b|\binfo\b|delivery|shipping|app)/i.test(cls)) {
          el.style.display = 'none';
          break;
        }
      }
    }
    var phrases = ["Stiahni si ARTMiE appku","Stiahni si ARTMIE appku","S aplikáciou doprava zdarma"];
    for (var k = 0; k < phrases.length; k++) {
      var p = phrases[k];
      var walker = document.createTreeWalker(document.body || document.documentElement, NodeFilter.SHOW_TEXT, null);
      var t;
      while ((t = walker.nextNode())) {
        if (t.nodeValue && t.nodeValue.indexOf(p) !== -1) {
          var node = t.parentElement;
          for (var m = 0; m < 6 && node && node.parentElement; m++) {
            var nc = node.className || '';
            nc = String(nc.baseVal !== undefined ? nc.baseVal : nc);
            var nt = node.tagName && node.tagName.toLowerCase();
            if (nt === 'li' || /(\brow\b|\bitem\b|\bcard\b|\bblock\b|\bpdp\b|\binfo\b|delivery|shipping|app)/i.test(nc)) {
              node.style.display = 'none';
              break;
            }
            node = node.parentElement;
          }
        }
      }
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', hideAppBlocks);
  else hideAppBlocks();
  setTimeout(hideAppBlocks, 500);
  setTimeout(hideAppBlocks, 1500);
  setTimeout(hideAppBlocks, 3000);

  /* URL prefix fix — only needed when on the subfolder (pre-cutover staging).
     On the dedicated domain (artmie.it) all internal /xxx links resolve correctly. */
  var MARKET_PREFIX = pathMode ? '/en-ie' : '';
  var MARKET_PREFIX_RX = /^\/(en-ie)(?:\/|$|\?|#)/;
  var SK_HOST_RX = /^https?:\/\/(www\.)?(app\.artmie\.sk|artmie\.sk|artmie\.com|czartmie\.myshopify\.com|20a254-6e\.myshopify\.com)/i;
  var SKIP_PATH_RX = /^\/(cart|checkout|localization|account\/login|account\/register|account\/logout|password|wpm@|tools\/|s\/files\/|recommendations\/|search\/suggest|apps\/|api\/|services\/|admin)(\/|\?|$)/;
  function normaliseHref(h) {
    if (!h) return null;
    if (/^(mailto:|tel:|sms:|javascript:|#)/i.test(h)) return null;
    if (!pathMode) return null; /* on dedicated domain — no prefix rewriting needed */
    if (SK_HOST_RX.test(h)) {
      h = h.replace(SK_HOST_RX, '');
      if (h === '' || h === '/') h = '/';
    } else if (/^https?:/i.test(h)) {
      return null;
    }
    if (h.charAt(0) !== '/') return null;
    if (MARKET_PREFIX_RX.test(h)) return null;
    /* Fix accidental concat like '/it-itpages/...' */
    var fixedConcat = h.match(new RegExp('^\\/en-ie([a-z])'));
    if (fixedConcat) return '/en-ie/' + h.slice(6);
    if (SKIP_PATH_RX.test(h)) return null;
    if (h === '/') return MARKET_PREFIX + '/';
    var stripped = h.replace(/^\/(sk|en)(\/|$)/, '/');
    return MARKET_PREFIX + stripped;
  }
  function fixHrefPrefix() {
    if (!pathMode) return;
    var anchors = document.querySelectorAll('a[href]');
    for (var i = 0; i < anchors.length; i++) {
      var a = anchors[i];
      var h = a.getAttribute('href');
      var newH = normaliseHref(h);
      if (newH && newH !== h) a.setAttribute('href', newH);
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fixHrefPrefix);
  else fixHrefPrefix();
  setTimeout(fixHrefPrefix, 500);
  setTimeout(fixHrefPrefix, 1500);
  setTimeout(fixHrefPrefix, 3000);

  /* SK → EN text rewrites */
  var TEXT_REWRITES = {
 "Stolové, ateliérové, poľné": "Tabletop, studio, field",
 "Königliche Talen": "Royal Talens",
 "Königliche Talens": "Royal Talens",
 "KÖNIGLICHE TALEN": "ROYAL TALENS",
 "KÖNIGLICHE TALENS": "ROYAL TALENS",
 "Späť na ": "Back to ",
 "Späť do obchodu": "Back to Store",
 "Najnovšie články": "Latest Articles",
 "Zobraziť všetky": "View All",
 "min čítania": "min read",
 "Čítať článok": "Read Article",
 "Čítať viac": "Read More",
 "min. čítania": "min read",
 "čítania": "reading",
 "Všetko": "All",
 "Hodnotenia zákazníkov": "Customer Reviews",
 "hodnoteni": "reviews",
 "hodnotení": "reviews",
 "hodnotenie": "review",
 "Recenzie": "Reviews",
 "recenzia": "review",
 "recenziu": "review",
 "recenzií": "reviews",
 "Napísať recenziu": "Write a Review",
 "Overená recenzia": "Verified Review",
 "Overena recenzia": "Verified Review",
 "Ďakujeme za tvoju recenziu": "Thank You for Your Review",
 "Tvoje hodnotenie": "Your Rating",
 "Podeľ sa o svoju skúsenosť": "Share Your Experience",
 "Pridať recenziu": "Add a Review",
 "Pridať do košíka": "Add to Cart",
 "Do košíka": "Add to Cart",
 "DO KOŠÍKA": "ADD TO CART",
 "Pridané do košíka": "Added to Cart",
 "Pridať všetky do košíka": "Add All to Cart",
 "Košík je prázdny": "Your Cart Is Empty",
 "Nákupný košík": "Shopping Cart",
 "Košík": "Cart",
 "v košíku": "in cart",
 "Zatvoriť": "Close",
 "Zavrieť": "Close",
 "Otvoriť": "Open",
 "Zobraziť": "Show",
 "Zobraziť všetko": "Show All",
 "Zobraziť viac": "Show More",
 "Zobraziť menej": "Show Less",
 "Skryť": "Hide",
 "Späť": "Back",
 "Pokračovať": "Continue",
 "Pokračovať v nákupe": "Continue Shopping",
 "Pokračovať na pokladňu": "Proceed to Checkout",
 "Hľadať": "Search",
 "Vyhľadať": "Search",
 "Vyhľadávanie": "Search",
 "Filtre": "Filters",
 "Vymazať": "Clear",
 "Vymazať všetko": "Clear All",
 "Triediť": "Sort",
 "Zoradiť": "Sort",
 "Načítavanie": "Loading",
 "Načítavam": "Loading",
 "Načítava sa": "Loading",
 "Načítať viac": "Load More",
 "Popis": "Description",
 "Parametre": "Parameters",
 "Vlastnosti": "Features",
 "Varianty": "Variants",
 "Vyberte": "Select",
 "Vyberte si": "Choose",
 "Veľkosť": "Size",
 "Farba": "Color",
 "Materiál": "Material",
 "Značka": "Brand",
 "Skladom": "In Stock",
 "Vypredané": "Sold Out",
 "Nedostupné": "Unavailable",
 "Posledné kusy": "Last Items",
 "Cena": "Price",
 "Bežná cena": "Regular Price",
 "Vaša cena": "Your Price",
 "Zľava": "Discount",
 "Akcia": "Sale",
 "Zľavnené": "Reduced",
 "Novinka": "New",
 "Stiahni si aplikáciu": "Download the App",
 "Prihlásenie": "Sign In",
 "Prihlásiť sa": "Sign In",
 "Odhlásiť sa": "Sign Out",
 "Registrácia": "Registration",
 "Nová registrácia": "New Registration",
 "Registrovať sa": "Register",
 "Môj účet": "My Account",
 "Objednávky": "Orders",
 "Adresy": "Addresses",
 "Heslo": "Password",
 "Zabudli ste heslo": "Forgot Your Password?",
 "Nemáte účet": "Don't Have an Account?",
 "Zoznam želaní": "Wishlist",
 "Pokladňa": "Checkout",
 "Doručenie": "Delivery",
 "Doprava": "Shipping",
 "Platba": "Payment",
 "Súhrn objednávky": "Order Summary",
 "Celkom": "Total",
 "Medzisúčet": "Subtotal",
 "Suma": "Amount",
 "DPH": "VAT",
 "Bez DPH": "Excluding VAT",
 "S DPH": "Including VAT",
 "Doprava zadarmo": "Shipping options at checkout",
 "Prihlásiť sa na odber": "Subscribe to the Newsletter",
 "Odoberať novinky": "Subscribe for Updates",
 "Najnovšie zľavy a inšpirácie": "Latest Discounts and Inspiration",
 "Súhlasím so spracovaním osobných údajov": "I Agree to the Processing of Personal Data",
 "Nenechajte si ujsť": "Don't Miss Out",
 "NENECHAJTE SI UJSŤ": "DON'T MISS OUT",
 "Pomoc a informácie": "Help and Information",
 "O nás": "About Us",
 "Kontaktujte nás": "Contact Us",
 "Sledujte nás": "Follow Us",
 "SLEDUJTE NÁS": "FOLLOW US",
 "Spôsoby platby": "Payment Methods",
 "Sme tu pre vás": "We're Here for You",
 "Odoslať": "Submit",
 "Poslať": "Send",
 "Uložiť": "Save",
 "Upraviť": "Edit",
 "Pridať": "Add",
 "Odstrániť": "Remove",
 "Zmazať": "Delete",
 "Potvrdiť": "Confirm",
 "Zrušiť": "Cancel",
 "Áno": "Yes",
 "Nie": "No",
 "voliteľné": "optional",
 "povinné": "required",
 "nepovinné": "optional",
 "súbor": "file",
 "súbory": "files",
 "fotografie": "photos",
 "fotka": "photo",
 "obrázok": "image",
 "meno": "first name",
 "priezvisko": "last name",
 "telefón": "phone",
 "správa": "message",
 "odpovedať": "reply",
 "Tvoje meno": "Your Name",
 "Tvoj email": "Your Email",
 "Fotka alebo video": "Photo or Video",
 "Pri preprave bohužiaľ došlo": "Unfortunately, an issue occurred during shipping",
 "Ohodnoť tento produkt": "Rate This Product",
 "Stránkovanie": "Pagination",
 "stránka": "page",
 "výsledkov": "results",
 "výsledok": "result",
 "Hodnotenia zakaznikov": "Customer Reviews",
 "Hodnotenia zakazníkov": "Customer Reviews",
 "Hodnotenie obchodu": "Store Rating",
 "Hodnotenia": "Reviews",
 "Hodnotenie": "Rating",
 "Na základe": "Based on",
 "Na zaklade": "Based on",
 "zákazníkov": "customers",
 "zakaznikov": "customers",
 "zákazník": "customer",
 "obchodu": "store",
 "obchod": "store",
 "Pridanie": "Adding",
 "pridať": "add",
 "pridava": "is being added",
 "Pridáva sa": "Adding",
 "pridáva sa": "adding",
 "akcie a trendy": "deals and trends",
 "AKCIE / TRENDY": "DEALS / TRENDS",
 "novinky a trendy": "new arrivals and trends",
 "kúpiť teraz": "buy now",
 "Kúpiť teraz": "Buy Now",
 "KÚPIŤ TERAZ": "BUY NOW",
 "Nakupuj teraz": "Shop Now",
 "Nakup teraz": "Shop Now",
 "NAKUPUJ TERAZ": "SHOP NOW",
 "na sklade": "in stock",
 "Na sklade": "In Stock",
 "NA SKLADE": "IN STOCK",
 "Nie je na sklade": "Out of Stock",
 "nie je na sklade": "out of stock",
 "doručenie": "delivery",
 "doručenia": "delivery",
 "Akcie & Trendy": "Deals & Trends",
 "AKCIE & TRENDY": "DEALS & TRENDS",
 "Zákazník": "Customer",
 "Zákaznícky servis": "Customer Service",
 "ZÁKAZNÍCKY SERVIS": "CUSTOMER SERVICE",
 "Alternatívne Produkty": "Alternative Products",
 "Alternatívne produkty": "Alternative products",
 "ALTERNATÍVNE PRODUKTY": "ALTERNATIVE PRODUCTS",
 "Alternatívny produkt": "Alternative Product",
 "alternatívne": "alternative",
 "zákaznícky servis": "customer service",
 "Farby a médiá": "Paints and Mediums",
 "Plátna a papiere": "Canvases and Paper",
 "Stojany": "Easels",
 "Štetce a pomôcky": "Brushes and Supplies",
 "Kreatívne potreby": "Craft Supplies",
 "Kreslenie": "Drawing",
 "Značky": "Brands",
 "Akryl, olej, akvarel": "Acrylic, Oil, Watercolor",
 "Na ráme, rolky, bloky": "Stretched Canvases, Rolls, Pads",
 "Zľavy až -80%": "Up to 80% Off",
 "Zľavy až": "Up to",
 "Bestseller, Novinky, Akcie": "Bestsellers, New Arrivals, Sale",
 "Akrylové, olejové, akvarelové": "Acrylic, Oil, Watercolor",
 "Kreslenie a ilustrácia": "Drawing and Illustration",
 "Sady, guľaté, ploché": "Sets, Round, Flat",
 "Živica, dekupáž, šperky": "Resin, Decoupage, Jewelry",
 "Ceruzky, pastely, fixy": "Pencils, Pastels, Markers",
 "O tejto kategórii": "About This Category",
 "O TEJTO KATEGÓRII": "ABOUT THIS CATEGORY",
 "O kategórii": "About the Category",
 "Plätzchen akzeptieren": "Accept Cookies",
 "Plätzchen ablehnen": "Reject Cookies",
 "Plätzchen-Einstellungen": "Cookie Settings",
 "Plätzchen verwalten": "Manage Cookies",
 "Wir verwenden Plätzchen": "We Use Cookies",
 "Plätzchen-Hinweis": "Cookie Notice",
 "Erforderliche Plätzchen": "Necessary Cookies",
 "Optionale Plätzchen": "Optional Cookies",
 "Marketing-Plätzchen": "Marketing Cookies",
 "Funktionale Plätzchen": "Functional Cookies",
 "Plätzchen-Richtlinie": "Cookie Policy",
 "Plätzchen": "Cookies",
 "Vyber variant": "Choose Variant",
 "Vyberte variant": "Choose Variant",
 "Vyberte variantu": "Choose Variant",
 "Vyberte si variantu": "Choose Variant",
 "Vyber variantu": "Choose Variant",
 "Môj zoznam želaní": "My Wish List",
 "Váš zoznam želaní je prázdny.": "Your wish list is empty.",
 "Váš zoznam želaní je prázdny": "Your wish list is empty",
 "Zoznam želaní je prázdny": "Wish list is empty",
 "Prezrieť produkty": "Browse products",
 "produktov": "products",
 "produktu": "product",
 "produkty": "products",
 "Doručenie do 1–2 pracovných dní": "Shipping options at checkout",
 "Doručenie do 1-2 pracovných dní": "Shipping options at checkout",
 "Dostava do 1–2 delovnih dni": "Shipping options at checkout",
 "Doručenie do 1–2 dní": "Shipping options at checkout",
 "Doručenie do 1-2 dní": "Shipping options at checkout",
 "S Packeta od 2,10 € · Zdarma nad 49 €": "Shipping options at checkout",
 "S Packeta od 2,10 €": "Shipping options at checkout",
 "Zdarma nad 49 €": "Shipping options at checkout",
 "100-dňové vrátenie bez udania dôvodu": "100-day returns, no reason required",
 "100-dňové vrátenie": "100-day returns",
 "bez udania dôvodu": "no reason required",
 "Jednoducho a bez starostí": "Simple and worry-free",
 "Bez starostí": "Worry-free",
 "PRIDAŤ DO KOŠÍKA": "ADD TO CART",
 "Pridané": "Added",
 "PRIDANÉ": "ADDED",
 "Všetky blogy": "All blogs",
 "Všetky články": "All articles",
 "Vyberte si tému, ktorá vás zaujíma": "Choose a topic that interests you",
 "Tipy, návody a inšpirácia pre rôzne maliarske techniky.": "Tips, tutorials, and inspiration for different painting techniques.",
 "Skicovanie, kreslenie a ilustrátorské tipy.": "Sketching, drawing, and illustration tips.",
 "Pomôžeme vám vybrať tie správne výtvarné potreby.": "We’ll help you choose the right art supplies.",
 "Tvorivé nápady a postupy krok za krokom.": "Creative ideas and step-by-step instructions.",
 "Inšpirácie zo sveta umenia a od umelcov.": "Inspiration from the world of art and artists.",
 "Tvorivé aktivity pre deti každého veku.": "Creative activities for kids of all ages.",
 "Aktuality, novinky a komunitné príspevky.": "News, updates, and community posts.",
 "Príbehy a informácie o značkách v našom sortimente.": "Stories and information about the brands in our range.",
 "Všetky blogy ARTMiE": "All ARTMiE Blogs",
 "Strinjam se s obchodnými podmienkami a zásadami ochrany osobných údajov": "I agree to the Terms and Conditions and Privacy Policy",
 "obchodnými podmienkami a zásadami ochrany osobných údajov": "Terms and Conditions and Privacy Policy",
 "obchodnými podmienkami": "Terms and Conditions",
 "obchodné podmienky": "Terms and Conditions",
 "zásadami ochrany osobných údajov": "Privacy Policy",
 "zásady ochrany osobných údajov": "Privacy Policy",
 "ochrany osobných údajov": "personal data protection",
 "ochrana osobných údajov": "personal data protection",
 "Max. 3 datoteke, do 5 MB. JPG, PNG alebo MP4.": "Max. 3 files, up to 5 MB. JPG, PNG, or MP4.",
 "JPG, PNG alebo MP4": "JPG, PNG, or MP4",
 "alebo MP4": "or MP4",
 "do 5 MB": "up to 5 MB",
 "Predchádzajúca stránka": "Previous Page",
 "Nasledujúca stránka": "Next Page",
 "Predošlá stránka": "Previous Page",
 "Ďalšia stránka": "Next Page",
 "Predošlá": "Previous",
 "Ďalšia": "Next",
 "Strana": "Page",
 "celkom": "total",
 "Triediť podľa": "Sort by",
 "Zoradiť podľa": "Sort by",
 "Najnovšie": "Newest",
 "Najstaršie": "Oldest",
 "Najpredávanejšie": "Best Sellers",
 "Cena: nízka → vysoká": "Price: Low → High",
 "Cena: vysoká → nízka": "Price: High → Low",
 "Cena vzostupne": "Price Ascending",
 "Cena zostupne": "Price Descending",
 "Názov A-Z": "Name A-Z",
 "Názov Z-A": "Name Z-A",
 "Manuálne": "Manual",
 "Náhodne": "Random",
 "Najlepšie hodnotené": "Top Rated",
 "Abecedne, A-Z": "Alphabetical, A-Z",
 "Abecedne, Z-A": "Alphabetical, Z-A",
 "Cena, od najvyššej": "Price, Highest First",
 "Cena, od najnižšej": "Price, Lowest First",
 "Dátum, od najnovšieho": "Date, Newest First",
 "Dátum, od najstaršieho": "Date, Oldest First",
 "Vyčistiť filtre": "Clear Filters",
 "Vymazať filtre": "Delete Filters",
 "Aktívne filtre": "Active Filters",
 "Vybrané": "Selected",
 "Aplikovať": "Apply",
 "Zobraziť výsledky": "Show Results",
 "Zobraziť produkty": "Show Products",
 "Skryť filtre": "Hide Filters",
 "Zobraziť filtre": "Show Filters",
 "Cenové rozpätie": "Price Range",
 "Cenová kategória": "Price Category",
 "Dostupnosť": "Availability",
 "Vypredáva sa": "Being Discontinued",
 "Skladom u dodávateľa": "In Stock at Supplier",
 "Žiadne výsledky": "No Results",
 "Žiadne produkty": "No Products",
 "Nič sa nenašlo": "Nothing Found",
 "Skús inú kombináciu filtrov": "Try a Different Filter Combination",
 "Načítavajú sa produkty": "Loading Products",
 "Načítavam produkty": "Loading Products",
 "Žiaden výsledok": "No Results",
 "položiek": "items",
 "produkt": "product",
 "Rýchle zobrazenie": "Quick View",
 "Rýchly náhľad": "Quick Preview",
 "Pridať do želaní": "Add to Wishlist",
 "Odstrániť zo želaní": "Remove from Wishlist",
 "Pridané do želaní": "Added to Wishlist",
 "V košíku": "In Cart",
 "Aktualizovať": "Update",
 "Z košíka": "Remove from Cart",
 "Späť k produktom": "Back to Products",
 "Súvisiace produkty": "Related Products",
 "Mohlo by vás zaujímať": "You Might Be Interested In",
 "Najnovšie produkty": "Newest Products",
 "Odporúčané produkty": "Recommended Products",
 "Naposledy zobrazené": "Recently Viewed",
 "Naposledy si pozeral": "You Recently Viewed",
 "Hmotnosť": "Weight",
 "Rozmery": "Dimensions",
 "Krajina pôvodu": "Country of Origin",
 "Záruka": "Warranty",
 "Kód produktu": "Product Code",
 "Označenie": "Label",
 "Kategória": "Category",
 "Kategórie": "Categories",
 "Pridať na zoznam želaní": "Add to Wishlist",
 "Pridať na wishlist": "Add to Wishlist",
 "Domovská stránka": "Home Page",
 "Hlavná stránka": "Home",
 "Všetky kategórie": "All Categories",
 "Prejsť k pokladni": "Proceed to Checkout",
 "Prejsť do košíka": "Go to Cart",
 "Suma celkom": "Total Amount",
 "Súčet": "Subtotal",
 "Vrátane DPH": "Including VAT",
 "Pridajte produkty": "Add Products",
 "Vyprázdniť košík": "Empty Cart",
 "Aktualizovať košík": "Update Cart",
 "Prihláste sa k odberu": "Subscribe",
 "Odoberajte naše novinky": "Subscribe to Our Newsletter",
 "Zadajte váš e-mail": "Enter Your Email",
 "Vaša e-mailová adresa": "Your Email Address",
 "Vaše meno": "Your Name",
 "Súhlasím so spracovaním": "I Agree to the Processing",
 "Prečítať si viac": "Read More",
 "Viac informácií": "More Information",
 "Vyhľadávanie produktov": "Product Search",
 "Zadajte hľadaný výraz": "Enter a Search Term",
 "Hľadať produkty": "Search Products",
 "Hľadať na webe": "Search the Website",
 "Hľadať produkt": "Search for a Product",
 "Načítať ďalšie": "Load More",
 "Načítať viac produktov": "Load More Products",
 "Filtre a triedenie": "Filters and Sorting",
 "Triedenie": "Sorting",
 "Všetky značky": "All Brands",
 "Všetky produkty": "All Products",
 "Zobraziť všetky produkty": "View All Products",
 "Otvoriť menu": "Open menu",
 "Zavrieť menu": "Close menu",
 "Prihlásiť": "Log In",
 "Zaregistrovať": "Register",
 "Vytvoriť konto": "Create an Account",
 "Vytvoriť účet": "Create an Account",
 "Moje adresy": "My Addresses",
 "Moje objednávky": "My Orders",
 "Moje údaje": "My Details",
 "Žiadne objednávky": "No Orders",
 "Stav objednávky": "Order Status",
 "Číslo objednávky": "Order Number",
 "Spôsob dopravy": "Shipping Method",
 "Spôsob doručenia": "Delivery Method",
 "Spôsob platby": "Payment Method",
 "Doručovacia adresa": "Shipping Address",
 "Fakturačná adresa": "Billing Address",
 "Adresa doručenia": "Delivery Address",
 "Hodnotenie produktu": "Product Rating",
 "Žiadne hodnotenia": "No Ratings",
 "Žiadne recenzie": "No Reviews",
 "Buďte prvý": "Be the First",
 "Napíšte prvú recenziu": "Write the First Review",
 "Prijať všetky": "Accept All",
 "Odmietnuť": "Reject",
 "Nastavenia": "Settings",
 "Spravovať": "Manage",
 "Súhlasím": "I Agree",
 "Tento web používa": "This Website Uses",
 "Používame súbory cookies": "We Use Cookies",
 "Toto je informácia o cookies": "This Is Cookie Information",
 "Bezpečné platby": "Secure Payments",
 "Rýchle doručenie": "Fast Delivery",
 "Vrátenie tovaru": "Returns",
 "14 dní na vrátenie": "14 Days to Return",
 "Záruka spokojnosti": "Satisfaction Guarantee",
 "Kvalitné výrobky": "Quality Products",
 "Motív": "Motif",
 "Štýl": "Style",
 "Izba": "Room",
 "Techniky": "Techniques",
 "Použitie": "Use",
 "Objem": "Volume",
 "Objem/Váha": "Volume/Weight",
 "Váha": "Weight",
 "Druh": "Type",
 "Forma": "Form",
 "Tvar": "Shape",
 "Tvrdosť": "Hardness (grade)",
 "Šírka": "Width",
 "Výška": "Height",
 "Dĺžka": "Length",
 "Hrúbka": "Thickness",
 "Priemer": "Diameter",
 "Počet kusov": "Number of Pieces",
 "Balenie": "Pack",
 "Zostava": "Set",
 "Súprava": "Set",
 "Pre koho": "Who It's For",
 "Vhodné pre": "Suitable For",
 "Vek": "Age",
 "Pohlavie": "Gender",
 "Sezóna": "Season",
 "Príležitosť": "Occasion",
 "Štýl výroby": "Production Style",
 "Ručná práca": "Handmade",
 "Zobrazenie": "View",
 "Mriežka": "Grid",
 "Zoznam": "List",
 "Otvoriť filter": "Open Filter",
 "Zatvoriť filter": "Close Filter",
 "Vybrať": "Select",
 "Vyber si": "Choose",
 "Stolové stojany": "Tabletop Easels",
 "Ateliérové stojany": "Studio Easels",
 "Poľné stojany do exteriéru": "Field Easels for Outdoor Use",
 "Poľné stojany": "Field Easels",
 "Maliarske stojany - všetky typy": "Painting Easels - All Types",
 "Maliarske stojany": "Painting Easels",
 "Umelecká lahôdka sa nenašla.": "Art supplies not found.",
 "Umelecká lahôdka sa nenašla": "Art supplies not found",
 "Najskôr ju teraz nemáme skladom. Pozrite si ďalšie obľúbené výtvarné potreby.": "They may be out of stock right now. Browse other popular art supplies.",
 "Najskôr ju teraz nemáme skladom.": "They may be out of stock right now.",
 "Pozrite si ďalšie obľúbené výtvarné potreby.": "Browse other popular art supplies.",
 "Prezerať e-shop": "Browse the Online Store",
 "PREZERAŤ E-SHOP": "BROWSE THE ONLINE STORE",
 "STIAHNITE SI NAŠU APLIKÁCIU": "DOWNLOAD OUR APP",
 "Stiahnite si našu aplikáciu": "Download our app",
 "Doprava a platba": "Shipping and Payment",
 "Výmena a vrátenie tovaru": "Exchanges and Returns",
 "Často kladené otázky": "Frequently Asked Questions",
 "Obchodné podmienky": "Terms and Conditions",
 "Ochrana osobných údajov": "Privacy Policy",
 "Spolupráca a veľkoodber": "Partnerships and Wholesale",
 "Pridaj sa do tímu ARTMIE": "Join the ARTMiE Team",
 "Po - Pi": "Mon - Fri",
 "Po-Pi": "Mon-Fri",
 "Slovensko": "Slovakia",
 "Hodnotenie obchodu na Heureka.sk": "Shop Rating on Heureka.sk",
 "Stranka": "Customer",
 "Zlatý certifikát Heureka": "Heureka Gold Certificate",
 "Zlatý certifikát": "Gold Certificate",
 "Overené strankami - 98 %": "Verified by Customers - 98%",
 "Overené strankami": "Verified by Customers",
 "Overené zákazníkmi": "Verified by Customers",
 "Shoproku 2019 - Víťaz": "Shop of the Year 2019 - Winner",
 "SHOPROKU 2024 - Víťaz": "SHOP OF THE YEAR 2024 - Winner",
 "Shoproku": "Shop of the Year",
 "Víťaz": "Winner",
 "VÍŤAZ": "WINNER",
 "Ručné práca a tvorenie": "Handicrafts and Crafting",
 "Ručná práca a tvorenie": "Handicrafts and Crafting",
 "Organizátor medzinárodnej súťaže": "Organizer of the International Competition",
 "Európsky sociálny fond": "European Social Fund",
 "Zamestnanosť a sociálna inklúzia": "Employment and Social Inclusion",
 "všetky typy": "all types",
 "všetky": "all",
 "všetkých": "all",
 "výtvarné potreby": "art supplies",
 "umelecké potreby": "art supplies",
 "výtvarné": "art",
 "umelecké": "artistic",
 "kreatívne": "creative",
 "lahôdka": "delicacy",
 "Všetky": "All",
 "VŠETKY": "ALL",
 "VŠETKO": "EVERYTHING",
 "Váš e-mail": "Your email",
 "Váš email": "Your email",
 "Vaše e-maily": "Your email addresses",
 "Tvoj e-mail": "Your email",
 "umeleckých potrieb": "of art supplies",
 "V našom e-shope": "In our online store",
 "V našom obchode": "In our store",
 "posielame zadarmo": "Shipping options at checkout",
 "pošta zadarmo": "Shipping options at checkout",
 "väčšina": "most",
 "väčšina produktov": "most products",
 "je skladom": "is in stock",
 "sú skladom": "are in stock",
 "rokov": "years",
 "Sme tu od roku": "We've been here since",
 "za tých vyše": "over the",
 "za tých": "these",
 "vyše 15 rokov": "over 15 years",
 "sa naučili jedno": "learned one thing",
 "na materiáli záleží": "materials matter",
 "Preto pracujeme výhradne so značkami": "That's why we work exclusively with brands",
 "o ktorých vieme": "that we know",
 "že neskhamú": "won't disappoint",
 "že nesklamú": "won't disappoint",
 "a je ich vyše": "and there are over",
 "štyridsať": "forty",
 "Maliarske plátna": "Canvases",
 "Maliarske plátna — základ, na ktorom všetko stojí": "Canvases, the foundation everything stands on",
 "základ, na ktorom všetko stojí": "the foundation everything rests on",
 "Štruktúrovacie pasty a efektové médiá ARTMIE": "ARTMiE Textured Pastes and Effect Mediums",
 "Štruktúrovacie pasty": "Textured Pastes",
 "efektové médiá": "effect mediums",
 "Naša vlastná značka": "Our own brand",
 "priniesla na slovenský trh": "brought to the Slovak market",
 "dostupné a kvalitné": "affordable and high-quality",
 "štruktúrovacie pasty": "textured pastes",
 "trojrozmerné textúry": "three-dimensional textures",
 "reliéfy a efekty": "reliefs and effects",
 "o akých si pred pár rokmi": "you could only dream of a few years ago",
 "Butter pasta": "Butter Paste",
 "Reliéfna pasta": "Relief Paste",
 "3D pasta": "3D Paste",
 "Maliarske plátno": "Canvas",
 "plátno na ráme": "stretched canvas",
 "plátna ECO": "ECO canvases",
 "plátna PROFI": "PROFI canvases",
 "plátno na rolke": "canvas roll",
 "okrúhle plátno": "round canvas",
 "plátno na lepenke": "canvas board",
 "dvojito šepsované": "double gesso-primed",
 "pripravené na okamžité maľovanie": "ready to paint right away",
 "akrylom": "with acrylics",
 "olejom": "with oils",
 "zmiešanými technikami": "with mixed media",
 "Ak hľadáš": "If you're looking for",
 "najlepší pomer ceny a kvality": "the best value for the price",
 "skús": "try",
 "Pre výstavy a profesionálnu tvorbu": "For exhibitions and professional work",
 "profesionálnu": "professional",
 "hrubším rámom a hustejším tkaním": "a thicker stretcher frame and a tighter weave",
 "A ak si radšej": "And if you'd rather",
 "pripravíš vlastný formát": "prepare your own format",
 "nastrihneš si presne toľko, koľko potrebuješ": "cut exactly as much as you need",
 "maliarskych plátien": "canvases",
 "akrylových farieb": "acrylic paints",
 "výrobcov": "manufacturers",
 "cez": "through",
 "až po": "up to",
 "ráme": "frames",
 "rolky": "rolls",
 "bloky": "pads",
 "metráž": "canvas by the meter",
 "dvoch": "two",
 "troch": "three",
 "jeden": "one",
 "Dnes Doprava ZADARMO Od 49€": "Shipping options at checkout",
 "Doprava ZADARMO Od 49€": "Shipping options at checkout",
 "Doprava ZADARMO Od 49 €": "Shipping options at checkout",
 "Doprava ZADARMO od 49€": "Shipping options at checkout",
 "Doprava ZADARMO od 49 €": "Shipping options at checkout",
 "doprava zadarmo od 49€": "Shipping options at checkout",
 "Doprava ZADARMO": "Shipping options at checkout",
 "DOPRAVA ZADARMO": "SHIPPING OPTIONS AT CHECKOUT",
 "doprava zadarmo": "shipping options at checkout",
 "Nakupuj teraz →": "Shop Now →",
 "Zadajte text...": "Enter text...",
 "Zadajte text": "Enter text",
 "Zadajte text vyhľadávania": "Enter a search term",
 "Zadajte hľadaný text": "Enter a search term",
 "Po - Ne / 9:00 - 20:00": "Mon - Sun / 9:00 - 20:00",
 "Po - Ne": "Mon - Sun",
 "Zákaznicky servis": "Customer Service",
 "ZÁKAZNICKY SERVIS": "CUSTOMER SERVICE",
 "Spoločnosť": "Company",
 "SPOLOČNOSŤ": "COMPANY",
 "E-SHOP ARTMIE": "ARTMiE E-SHOP",
 "E-shop ARTMIE": "ARTMiE E-Shop",
 "POMOC A INFORMÁCIE": "HELP AND INFORMATION",
 "Sociálne médiá": "Social Media",
 "SOCIÁLNE MÉDIÁ": "SOCIAL MEDIA",
 "PRIHLÁSENIE": "SIGN IN",
 "NOVÁ REGISTRÁCIA": "NEW REGISTRATION",
 "Inšpirácia, techniky a tipy pre každého umelca": "Inspiration, Techniques, and Tips for Every Artist",
 "Inšpirácia": "Inspiration",
 "INŠPIRÁCIA": "INSPIRATION",
 "inšpirácia": "inspiration",
 "inšpirácie": "inspirations",
 "inšpiráciu": "inspiration",
 "techniky a tipy": "techniques and tips",
 "TECHNIKY A TIPY": "TECHNIQUES AND TIPS",
 "pre každého umelca": "for every artist",
 "pre každého": "for everyone",
 "každého umelca": "every artist",
 "umelca": "artist",
 "umelcov": "artists",
 "umelec": "artist",
 "umelci": "artists",
 "umelecké potreby pre Vaše umenie": "art supplies for your art",
 "pre Vaše umenie": "for your art",
 "pre vaše umenie": "for your art",
 "vaše umenie": "your art",
 "Výpredaj": "Sale",
 "VÝPREDAJ": "SALE",
 "výpredaj": "sale",
 "naozaj": "really",
 "najmä": "especially",
 "avšak": "however",
 "predovšetkým": "above all",
 "najprv": "first",
 "nakoniec": "finally",
 "potom": "then",
 "predtým": "before",
 "samozrejme": "of course",
 "najlepší": "best",
 "najlepšia": "best",
 "najlepšie": "best",
 "najvyšší": "highest",
 "najnižší": "lowest",
 "Späť na menu": "Back to menu",
 "Prejsť na obsah": "Skip to content",
 "Prejsť na zoznam výsledkov": "Skip to results list",
 "Prejsť na ": "Skip to ",
 "Ďalšie možnosti prihlásenia": "Other sign-in options",
 "Sociálne prihlásenie": "Social sign-in",
 "Filtrovať podľa": "Filter by",
 "Filtrovať": "Filter",
 "položky": "items",
 "položka": "item",
 "Kúpiť": "Buy",
 "Pokračujte v nákupe": "Continue shopping",
 "Pridať do zoznamu želaní": "Add to wish list",
 "Pokračovať k pokladni": "Continue to checkout",
 "Odhlásiť": "Sign out",
 "Zaregistrovať sa": "Sign up",
 "Vypredan": "Sold out",
 "Množstvo": "Quantity",
 "Mnoz": "Qty",
 "Váš košík": "Your cart",
 "Váš košík je prázdny": "Your cart is empty",
 "Pokračovať do pokladne": "Proceed to checkout",
 "Špeciálna cena": "Special price",
 "Recenzia": "Review",
 "Prihlásiť sa na odber noviniek": "Subscribe to our newsletter",
 "FILTRE:": "FILTERS:",
 "FILTRE": "FILTERS",
 "Filtre:": "Filters:",
 "filtre:": "filters:",
 "filtre": "filters",
 "VYMAZAŤ VŠETKO": "CLEAR ALL",
 "VYMAZAŤ": "CLEAR",
 "vymazať všetko": "clear all",
 "vymazať": "clear",
 "TRIEDIŤ": "SORT",
 "ZORADIŤ": "SORT",
 "CENA": "PRICE",
 "CENOVÉ ROZPÄTIE": "PRICE RANGE",
 "FARBA": "COLOR",
 "POUŽITIE": "USE",
 "PRE KOHO": "FOR WHOM",
 "ZNAČKA": "BRAND",
 "KRAJINA PÔVODU": "COUNTRY OF ORIGIN",
 "BALENIE": "PACK",
 "OBJEM": "VOLUME",
 "OBJEM/VÁHA": "VOLUME/WEIGHT",
 "TVAR": "SHAPE",
 "VEĽKOSŤ": "SIZE",
 "MATERIÁL": "MATERIAL",
 "TECHNIKY": "TECHNIQUES",
 "PRÍLEŽITOSŤ": "OCCASION",
 "DOSTUPNOSŤ": "AVAILABILITY",
 "ZĽAVA": "DISCOUNT",
 "AKCIA": "SALE",
 "Mostra di più": "Show more",
 "kategórie": "categories",
 "KATEGÓRIE": "CATEGORIES",
 "Domov": "Home",
 "Bez ceny": "No price",
 "Načítava sa…": "Loading…",
 "Načítava sa...": "Loading...",
 "Otvoriť chat": "Open chat",
 "NAČÍTAŤ VIAC": "LOAD MORE",
 "Hľadať...": "Search...",
 "Odosielame ešte v ten istý deň": "Ships the same day",
 "Formát": "Format",
 "Gramáž papiera": "Paper weight",
 "Predchádzajúce": "Previous",
 "Ďalšie": "Next",
 "Hrúbka pera": "Pen nib size",
 "Naše značky": "Our brands",
 "Prémiové umelecké potreby od osvedčených svetových značiek": "Premium art supplies from trusted global brands",
 "ARTMIE – Unsere Hausmarke für Qualität und Vielfalt": "ARTMiE – Our House Brand for Quality and Variety",
 "KREUL – Kreativität für alle Altersgruppen": "KREUL – Creativity for All Age Groups",
 "Daler-Rowney – Britische Qualität für anspruchsvolle Arbeit": "Daler-Rowney – British Quality for Demanding Work",
 "Was unsere Kunden am häufigsten kaufen": "What Our Customers Buy Most Often",
 "Häufige Fehler — und wie du sie vermeidest": "Common Mistakes — and How to Avoid Them",
 "Häufig gestellte Fragen": "Frequently Asked Questions",
 "Produkte für Anfänger": "Products for Beginners",
 "Eignet sich Malen nach Zahlen auch für absolute Anfänger?": "Is Paint by Numbers Suitable for Complete Beginners?",
 "Bei ARTMIE findest du ergänzend": "At ARTMiE, you’ll also find",
 "Akú silikónovú formu na živicu vybrať?": "Which Silicone Mold Should You Choose for Resin?",
 "Na čo Tvar Príklady": "What For Shape Examples",
 "Geódy nepravidelný tvar kameňa geóda": "Geodes irregular stone shape geode",
 "Dá sa silikónová forma použiť viackrát?": "Can a Silicone Mold Be Used More Than Once?",
 "Aký materiál sa do silikónovej formy odlieva?": "What Material Is Cast in a Silicone Mold?",
 "Ako si vyrobiť vlastnú silikónovú formu?": "How Do You Make Your Own Silicone Mold?",
 "Kedy vybrať živicu z formy?": "When Should You Remove Resin from the Mold?",
 "Epoxidová živica Modelovanie a odlievanie": "Epoxy Resin Modeling and Casting",
 "Silikónové formy na živicu": "Silicone Molds for Resin",
 "Na čo": "What For",
 "Príklady": "Examples",
 "Šperky a prívesky": "Jewelry and Pendants",
 "drahokamy, prívesky, kľúčenky": "gemstones, pendants, keychains",
 "prívesky s kľúčenkou": "keychain pendants",
 "Podnosy a podšálky": "Trays and Coasters",
 "väčšie interiérové kúsky": "larger interior pieces",
 "Pebeo podšálky": "Pebeo coasters",
 "Geódy": "Geodes",
 "nepravidelný tvar kameňa": "irregular stone shape",
 "geóda": "geode",
 "plytké dekorácie": "shallow decorations",
 "Vlastná forma": "Your Own Mold",
 "odtlačok ľubovoľného predmetu": "an impression of any object",
 "Živicu, pigmenty a pomôcky nájdeš v kategórii": "You’ll find resin, pigments, and tools in the category",
 "epoxidová živica na odlievanie": "epoxy resin for casting",
 "Epoxidová živica": "Epoxy Resin",
 "Na rolke aj napnuté na ráme · z vlastnej výroby": "On a roll or stretched on a frame · made in-house",
 "Maliarske plátna z vlastnej dielne": "Canvas from Our Own Workshop",
 "Začnite tu": "Start Here",
 "Ostatné plátna z našej dielne": "Other Canvas from Our Workshop",
 "Práve v zľave": "Currently on Sale"
};

  /* Loop guard: filter out pairs whose replacement contains the source */
  var TEXT_KEYS = Object.keys(TEXT_REWRITES)
    .filter(function (k) { return TEXT_REWRITES[k].indexOf(k) === -1; })
    .sort(function (a, b) { return b.length - a.length; });

  /* ARTMIE_PERF_REWRITER_2026-07-07 v2 — engine optimization, behavior-identical:
     (1) ONE precompiled combined regex (TEXT_KEYS already longest-first; JS alternation
         picks the first alternative at a position, preserving longest-first semantics);
     (2) MutationObserver walks ONLY ADDED subtrees, not the whole body.
     Revert: cmp/rewriterbackups/. */
  var COMBINED_RX = null;
  try {
    COMBINED_RX = new RegExp(TEXT_KEYS.map(function (k) {
      var e = k.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
      if (/^[\x00-\x7F]+$/.test(k) && k.trim().length <= 12) e = '(?<![A-Za-z\u00C0-\u024F])' + e + '(?![A-Za-z\u00C0-\u024F])';
      return e;
    }).join('|'), 'g');
  } catch (e) {}
  function rewriteViaMap(m) { return Object.prototype.hasOwnProperty.call(TEXT_REWRITES, m) ? TEXT_REWRITES[m] : m; }
  function rewriteTextNode(node) {
    if (!node || node.nodeType !== 3) return;
    var t = node.nodeValue;
    if (!t || !/\S/.test(t) || !COMBINED_RX) return;
    COMBINED_RX.lastIndex = 0;
    var newT = t.replace(COMBINED_RX, rewriteViaMap);
    if (newT !== t) node.nodeValue = newT;
  }
  function rewriteString(v) {
    if (!v || !COMBINED_RX) return v;
    COMBINED_RX.lastIndex = 0;
    return v.replace(COMBINED_RX, rewriteViaMap);
  }
  function walkAndRewrite(root) {
    if (!root) return;
    if (root.nodeType === 3) { rewriteTextNode(root); return; }
    var w = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null, false);
    var n; while ((n = w.nextNode())) rewriteTextNode(n);
    var ATTR_SELECTORS = ['[placeholder]', '[alt]', '[title]', '[aria-label]', 'input[type="submit"]', 'input[type="button"]', 'button'];
    var atrs = root.querySelectorAll ? root.querySelectorAll(ATTR_SELECTORS.join(',')) : [];
    for (var i = 0; i < atrs.length; i++) {
      var el = atrs[i];
      ['placeholder', 'alt', 'title', 'aria-label', 'value'].forEach(function (a) {
        var v = el.getAttribute(a);
        if (!v) return;
        var nv = rewriteString(v);
        if (nv !== v) el.setAttribute(a, nv);
      });
    }
  }
  function initialPass() { walkAndRewrite(document.body); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialPass);
  else initialPass();

  var pendingNodes = [];
  var pending = null;
  function flushPending() {
    pending = null;
    var nodes = pendingNodes; pendingNodes = [];
    for (var i = 0; i < nodes.length; i++) { if (nodes[i]) walkAndRewrite(nodes[i]); }
    fixHrefPrefix();
  }
  function startObserver() {
    if (!document.body) { setTimeout(startObserver, 100); return; }
    try {
      var mo = new MutationObserver(function (muts) {
        for (var i = 0; i < muts.length; i++) {
          var added = muts[i].addedNodes;
          for (var j = 0; j < added.length; j++) {
            var nd = added[j];
            if (nd.nodeType === 1 || nd.nodeType === 3) pendingNodes.push(nd);
          }
        }
        if (pendingNodes.length && !pending) pending = setTimeout(flushPending, 300);
      });
      mo.observe(document.body, { childList: true, subtree: true });
    } catch (e) {}
  }
  startObserver();

  document.addEventListener('click', function (e) {
    var a = e.target && e.target.closest && e.target.closest('a[href]');
    if (!a) return;
    var h = a.getAttribute('href');
    var newH = normaliseHref(h);
    if (newH && newH !== h) a.setAttribute('href', newH);
  }, true);


  /* === phase-67-start === HANDLE LOCALIZATION === */
  var PAGE_HANDLES_IE = {
 "o-nas": "about-us",
 "doprava-a-platba": "shipping-and-payment",
 "casto-kladene-otazky-faq": "frequently-asked-questions-faq",
 "vseobecne-obchodne-podmienky": "terms-and-conditions",
 "pridaj-sa-do-timu-artmie": "join-the-artmie-team",
 "kontakt": "contact-2",
 "nase-zaruky": "our-guarantees",
 "kvalita-sluzieb-a-reklamacie": "service-quality-and-claims",
 "sposob-platby-a-dodanie": "payment-and-delivery-methods",
 "vymena-a-vratenie-tovaru": "returns-and-exchanges",
 "ako-vyplnit-reklamacny-formular": "how-to-fill-out-a-claim-form",
 "spolupraca-a-velkoodber": "partnerships-and-wholesale",
 "stan-sa-reziserom-svojho-umenia": "become-the-director-of-your-art",
 "pravidla-artmie-bazarika": "artmie-bazaar-rules",
 "artmie-social-login-tos": "artmie-social-login-terms-of-use",
 "gdpr-podmienky-ochrany-osobnych-udajov": "gdpr-personal-data-protection-policy",
 "vsetky-blogy": "all-blog-posts",
 "odstupenie-od-zmlvy-a-vratenie-tovaru": "returns-and-claims",
 "odstupenie-od-zmluvy-zrusenim-objednavky": "canceling-an-order",
 "autor-valerian-grass": "valerian-grass-artist-at-artmie",
 "autor-ondrej-marcinov": "ondrej-marcinov-author-at-artmie",
 "autorka-dana-grass": "dana-grass-author-at-artmie",
 "autorka-ingrid-pohlova": "ingrid-pohlova-author-at-artmie",
 "vsetky-maliarske-platna": "canvases-from-our-own-workshop",
 "poistenie-zasielky": "shipping-insurance"
};
  var BLOG_HANDLES_IE = {
 "nase-znacky": "our-brands",
 "artmie-nase-znacky": "artmie-brands",
 "techniky-malby": "painting-techniques",
 "kreslenie-a-ilustracia": "drawing-and-illustration",
 "sprievodca-potrebami": "art-supplies-guide",
 "diy-kreativne-projekty": "diy-and-creative-projects",
 "svet-umenia": "the-world-of-art-and-inspiration",
 "tvorenie-s-detmi": "crafting-with-kids",
 "novinky-a-komunita": "news-and-community"
};
  var ARTICLE_HANDLES_IE = {
 "od-skicovania-k-malovaniu-akrylove-fixy-kreul-triton-s-tebou-udrzia-tempo": "from-sketching-to-painting-kreul-triton-acrylic-markers-keep",
 "v-kreul-tovarni-na-farby": "come-take-a-look-inside-the-kreul-factory-with-us",
 "podte-sa-s-nami-pozriet-na-vyrobu-stetcov-priamo-do-dielne-da-vinci": "with-da-vinci-products-we-always-talk-about-handcraft-and-hi",
 "aky-vsestranny-je-akryl-solo-goya-triton": "how-versatile-is-solo-goya-triton-acrylic-paint",
 "akrylove-fixky-amsterdam": "why-are-amsterdam-markers-the-best",
 "schmincke-horadam-na-slovensku-sprievodca-seriami-a-kde-ich-kupit": "schmincke-horadam-in-slovakia-a-guide-to-the-series-and-wher",
 "royal-talens-amsterdam-standard-expert-alebo-art-creation-ktory-akryl-si-vybrat": "royal-talens-amsterdam-standard-expert-or-art-creation-which",
 "assemblage-vs-kolaz-aky-je-rozdiel-a-ako-tieto-techniky-kreativne-spojit": "assemblage-vs-collage-what-s-the-difference-and-how-can-you",
 "ako-malovat-na-sklo-akrylovymi-farbami-premena-sklenenych-predmetov-krok-za-krokom": "how-to-paint-on-glass-with-acrylic-paints-transform-glass-ob",
 "tiitle-oilako-pouzivat-olejove-farby-media-impasto-techniky": "oil-painting-basics-how-to-use-oils-and-mediums-for-striking",
 "ako-vytvorit-geometricke-umenie-s-texturou": "step-by-step-with-martin-horecny-how-to-create-textured-geom",
 "zatisie-a-perspektiva-objavuj-s-kazdym-tahom": "still-life-and-perspective-discover-with-every-stroke",
 "folk-kraslice-2": "quick-guide-to-folk-easter-eggs-or-a-last-minute-easter-scra",
 "ako-si-vybrat-stojan-1": "5-tips-for-choosing-the-right-easel",
 "objav-novu-artmie-aplikaciu-tvoj-umelecky-pomocnik-vo-vrecku": "discover-the-new-artmie-app-your-art-assistant-in-your-pocke",
 "ako-pouzit-butter-paste-na-vytvorenie-uzasnej-textury-jednoduche-tipy-a-techniky": "how-to-use-butter-paste-to-create-amazing-texture-easy-tips",
 "kuzlenie-s-farbami-jednoduchy-sposob-ako-vdychnut-strukturovacej-paste-zivot": "creating-magic-with-paint-an-easy-way-to-bring-texture-paste",
 "ako-na-jemne-akvarelove-prechody-jednoduchy-trik-na-snove-pozadia": "how-to-create-subtle-watercolor-gradients-a-simple-trick-for",
 "pridaj-hlbku-vytvor-ocarujuce-3d-efekty-pomocou-sablonovej-farby-na-skle": "create-charming-3d-effects-on-glass-with-stencil-paint",
 "letna-magia-akvarelu-malovanie-vonku-ako-nova-zaluba": "summer-watercolor-magic-painting-outdoors-as-a-new-hobby",
 "zmiesanie-praskajucej-pasty-s-akrylovou-farbou-co-sa-stane-ked-zlato-stretne-bielu": "mixing-crackle-paste-with-acrylic-paint-what-happens-when-go",
 "ako-ziskat-sytu-nepriehladnost-s-gvasom-prakticky-sprievodca-pre-kreativne-duse": "how-to-get-opaque-vivid-color-with-gouache-a-practical-guide",
 "ako-vytvorit-impasto-efekty-pomocou-farieb-gouache": "how-to-create-impasto-effects-with-gouache",
 "sprievodca-pridanim-metalickych-akcentov-do-tvojho-umenia": "bring-on-the-gloss-a-guide-to-adding-metallic-accents-to-you",
 "objav-kuzlo-textury-so-strukturovacou-pastou": "discover-the-magic-of-texture-with-modeling-paste",
 "miesanie-akvarelovych-farieb": "mix-watercolors-like-a-pro-beyond-basic-color-theory",
 "4-tekute-techniky-kreul-triton-liquid": "playing-with-acrylic-paints-4-tips-for-abstract-acrylic-and",
 "tvorime-s-metalickou-pastou-artmie-midas": "new-possibilities-with-artmie-midas-fluid-metallic-paste",
 "ako-sme-premenili-stetec-na-maliarske-platno": "how-to-paint-a-portrait-on-a-brush-tips-for-painting-on-unus",
 "11-praktickych-rad-pri-tvorbe-plaster-art-so-strukturnou-pastou": "11-practical-tips-for-creating-plaster-art-with-texture-past",
 "plaster-art-v-artmie-horuci-trend-sme-vyskusali-na-vlastnej-kozi": "plaster-art-at-artmie-we-tried-the-hot-trend-ourselves",
 "ako-na-akrylove-farby": "how-to-use-acrylic-paints-benefits-tips-and-advice-for-begin",
 "nauc-sa-malovat-gvasovymi-farbami": "how-to-paint-with-gouache-great-tips-from-artmie",
 "vytvor-obraz-technikou-pouring": "your-guide-to-the-pouring-art-technique",
 "ako-pozlatit-ci-patinovat-dielo": "how-to-gild-or-patinate-an-artwork",
 "10-dovodov-preco-by-ste-mali-zacat-s-mixed-media-technikou": "10-reasons-to-start-with-the-mixed-media-technique",
 "ako-malovat-gvasovymi-farbami": "how-to-paint-with-gouache",
 "ako-malovat-atramentmi": "how-to-paint-with-inks",
 "malujeme-izbove-rastliny-akvarelovymi-farbami-van-gogh": "creating-magic-with-van-gogh-watercolors-houseplants",
 "ako-pouzivat-spachtle-malujeme-jarnu-luku": "how-to-use-palette-knives-painting-a-spring-meadow",
 "5-sposobov-ako-namalovat-macku": "5-ways-to-paint-a-cat",
 "ako-zacat-s-akrylovymi-farbami": "how-to-get-started-with-acrylic-paints",
 "malba-v-pleneri-podme-spolu-objavit-krasy-prirody": "plein-air-painting-let-s-discover-the-beauty-of-nature-toget",
 "spoznajte-caro-prace-s-olejovymi-farbami": "oil-painting-for-beginners-how-to-get-started-with-oil-paint",
 "ako-zacat-s-olejovymi-farbami": "get-to-know-oil-paints-with-us",
 "ako-malovat-krajinku-navod": "how-to-paint-a-landscape-tutorial",
 "ako-namalovat-kvet-akvarelom": "how-to-paint-flowers-in-watercolor",
 "ako-jednoducho-namalovat-ruzu": "how-to-paint-a-rose-easily",
 "ako-miesat-akrylove-faby": "how-to-mix-acrylic-paints",
 "malovanie-na-textil-ta-uchvati": "painting-on-fabric-how-to-paint-a-t-shirt-step-by-step",
 "ako-pracovat-s-akrylom": "how-to-paint-with-acrylics",
 "ako-na-vianocny-obraz": "how-to-paint-an-original-christmas-picture",
 "farby-svietiace-v-tme-1": "10-tips-for-painting-with-glow-in-the-dark-paints",
 "ako-malovat-s-farbami-na-textil": "how-to-paint-on-fabric",
 "tvorenie-s-pouring-mediom": "acrylic-paint-pouring-harmony-in-the-flow",
 "techniky-malovania-do-vrecka": "which-painting-techniques-should-you-know-like-the-back-of-y",
 "spachtlova-technika-impasto": "try-the-palette-knife-technique",
 "malovanie-na-hodvab": "silk-painting-works-wonders-see-for-yourself",
 "duhove-glazury-na-keramike-umelecka-dielna-briana-giniewskiho": "rainbow-glazes-on-ceramics-brian-giniewski-s-art-studio",
 "ktore-platno-je-lepsie-bavlnene-alebo-lanove": "which-canvas-is-better-for-you-cotton-or-linen",
 "ako-natiahnut-platno-na-ram": "want-to-stretch-a-canvas-what-you-need-to-know",
 "kolko-vies-o-anatomii-malovacich-stetcov": "how-much-do-you-know-about-the-anatomy-of-paintbrushes",
 "vedeli-ste-uz-o-olejovych-farbach-rieditelnych-vodou": "have-you-heard-of-water-mixable-oil-paints",
 "kreativna-nezvycajna-kombinacia-tus-a-olejove-pastely": "a-creative-and-unusual-combination-ink-and-oil-pastels",
 "skusili-ste-uz-roztok-na-express-transfer": "have-you-tried-express-transfer-solution",
 "co-je-pre-vas-lepsie-bavlnene-alebo-lanove-platno": "which-is-better-for-you-cotton-or-linen-canvas",
 "co-vies-o-anatomii-stetcov-na-malovanie": "what-do-you-know-about-the-anatomy-of-a-paintbrush",
 "farby-na-olej-riedene-vodou": "water-mixable-oil-paints-how-they-work-and-what-to-thin-them",
 "ktore-su-lepsie-prirodne-stetce-alebo-synteticke": "which-are-better-natural-or-synthetic-brushes",
 "kolko-viete-o-anatomii-stetcov": "how-much-do-you-know-about-brush-anatomy",
 "mozno-neviete-ze-akrylove-farby-maju-tieto-vlastnosti": "did-you-know-acrylic-paints-have-these-properties",
 "co-su-a-na-co-sluzia-akrylove-strukturove-pasty": "what-are-acrylic-texture-pastes-and-what-are-they-used-for",
 "ako-spravne-cistit-stetce-po-malovani": "how-to-clean-brushes-after-painting",
 "co-su-akrylove-strukturalne-pasty-a-na-co-sluzia": "what-are-acrylic-texture-pastes-and-what-are-they-used-for",
 "poznate-vsetky-tajomstva-pouring-techniky": "do-you-know-all-the-secrets-of-the-pouring-technique",
 "co-je-pre-teba-lepsie-prirodne-alebo-synteticke-stetce": "which-are-better-for-you-natural-or-synthetic-brushes",
 "vedeli-ste-ze-akrylova-farba-ma-tyto-vlastnosti": "did-you-know-acrylic-paint-has-these-properties",
 "plaster-art-technika-3d-reliefov": "plaster-art-a-complete-guide-to-creating-3d-reliefs-at-home",
 "ako-malovat-s-gvasom-techniky-pre-zaciatocnikov": "how-to-paint-with-gouache-a-complete-guide-to-techniques-for",
 "ako-malovat-akvarelovymi-ceruzkami-techniky-a-efekty": "how-to-paint-with-watercolor-pencils-a-complete-guide-to-tec",
 "5-veci-ktore-musite-vediet-pred-malovanim-na-textil": "5-things-you-need-to-know-before-painting-on-fabric",
 "artmie-inktober-challenge-sutaz-kreslenia-atramentom": "artmie-inktober-complete-guide-to-the-annual-challenge-for-a",
 "12-tipov-pre-zaciatocnikov-ako-zacat-s-malovanim-akvarelom": "12-tips-for-beginners-how-to-get-started-with-watercolor-pai",
 "5-trikov-ako-neplytvat-farbami-na-malovanie": "5-tricks-for-wasting-less-paint",
 "je-to-mozne-a-ako-malovat-na-nenatiahnutom-platne": "is-it-possible-to-paint-on-unstretched-canvas",
 "da-sa-malovat-vodovymi-farbami-na-platno": "can-you-paint-on-canvas-with-watercolors",
 "objavili-ste-uz-carovne-tajomstva-akvarelovych-fixiek": "have-you-discovered-the-magical-secrets-of-watercolor-marker",
 "co-je-to-malovanie-jednym-tahom-one-stroke-painting": "what-is-one-stroke-painting-one-stroke-painting",
 "kolko-toho-v-skutocnosti-vies-o-akvarelovej-technike": "how-much-do-you-really-know-about-watercolor-technique",
 "vsetko-co-musite-vediet-o-malovani-temperami": "everything-you-need-to-know-about-painting-with-tempera-pain",
 "preco-a-ako-maliari-kombinuju-olejove-a-akrylove-farby": "why-and-how-do-painters-combine-oil-and-acrylic-paints",
 "malovanie-na-platno-pre-zaciatocnikov": "painting-on-canvas-for-beginners-how-to-get-started-step-by",
 "ako-blendovat-farby-stetcovymi-fixkami-jednoduche-ombre-efekty": "how-to-blend-colors-with-brush-pens-simple-ombre-effects",
 "kaligrafia-a-hand-lettering-preco-to-skusit": "calligraphy-and-hand-lettering-why-try-it",
 "kreslenie-ceruzkou-prva-cast": "pencil-drawing-tips-for-beginners-and-advanced-artists",
 "nakresli-si-s-nami-snezienky-artmie": "draw-snowdrops-with-us-artmie",
 "ako-nakreslit-nadherneho-motyla": "how-to-draw-a-beautiful-butterfly",
 "ako-na-umenie-kaligrafie-ci-ako-si-zlepsit-krasopis": "how-to-get-started-with-calligraphy-or-improve-your-handwrit",
 "ako-nakreslit-postavu-navod": "how-to-draw-a-figure-a-guide",
 "linoryt-pre-zaciatocnikov-ako-si-vyrobit-peciatku": "linocut-for-beginners-how-to-make-a-stamp",
 "ako-na-sketchbook-zosit": "how-to-start-a-sketchbook",
 "urban-skicovanie-do-ulic-s-perom-a-stetcom": "urban-sketching-take-to-the-streets-with-a-pen-and-brush",
 "kreslit-s-copic-markermi": "create-manga-and-comics-with-copic-markers",
 "kreslenie-ceruzkou-od-teorie-k-praxi": "pencil-drawing-from-theory-to-practice",
 "kreslime-ceruzkou-nauc-sa-techniky-kreslenia": "drawing-with-a-pencil-learn-drawing-techniques",
 "4-fantasticke-triky-pre-lepsie-kreslenie": "4-fantastic-tricks-for-better-drawing",
 "kurzivne-pismo": "cursive-writing",
 "napady-na-kreslenie": "drawing-ideas",
 "ako-nakreslit-macku-navod-pre-zaciatocnikov": "how-to-draw-a-cat-complete-step-by-step-guide-for-beginners",
 "ako-nakreslit-zajacika-krok-za-krokom": "how-to-draw-a-bunny-a-simple-step-by-step-guide-for-everyone",
 "ako-nakreslit-psa-navod-krok-za-krokom": "how-to-draw-a-dog-complete-step-by-step-guide-for-beginners",
 "kaligrafia-pre-zaciatocnikov-navod": "calligraphy-for-beginners-a-complete-guide-to-the-art-of-bea",
 "stetce-pocity-nasleduj-svoju-ruku-a-svoje-srdce": "brushes-and-feelings-follow-your-hand-and-your-heart",
 "ako-si-vybrat-spravne-maliarske-platno-porovnanie-eko-bavlnenych-a-lanovych-platien": "how-to-choose-the-right-canvas-comparing-eco-cotton-and-line",
 "ako-spravne-drzat-maliarsku-paletu-jednoduchy-navod-pre-pohodlne-malovanie": "how-to-hold-a-paint-palette-properly-a-simple-guide-to-comfo",
 "objavovanie-umeleckych-textur-maslova-pasta-vs-reliefna-pasta": "exploring-artistic-textures-with-martin-horecny-butter-paste",
 "6-klucovych-veci-ktore-by-mal-kazdy-umelec-vediet-o-akrylovych-farbach": "unlock-the-magic-6-key-things-every-artist-should-know-about",
 "skicar-hahnemuhle-dennik-profesionalneho-umelca": "hahnemuhle-sketchbook-a-professional-artist-s-journal",
 "daj-dielu-hlbku-artmie-butter-pastou": "give-your-artwork-depth-with-artmie-butter-paste",
 "artmieskblogsprievodca_olejovymi_pastelmi": "introduction-to-oil-pastels-a-complete-guide-for-beginners",
 "tvor-kvalitne-pomocou-lanoveho-platna-museal": "create-art-like-the-old-masters-with-museal-linen-canvas",
 "kliny-na-platno-ako-ich-pouzit-a-kedy": "stretcher-keys-for-canvas-how-and-when-to-use-them",
 "ako-zaramovat-papier-aby-sa-nevlnil": "how-to-prevent-paper-from-buckling-in-a-frame",
 "olejove-farby-vlastnosti-a-zakladne-pigmenty": "oil-paints-properties-and-basic-pigments",
 "co-vsetko-dokazu-artmie-spachtle": "make-magic-on-canvas-what-can-artmie-palette-knives-do",
 "ako-opravit-maliarske-platno": "how-to-fix-a-dented-canvas",
 "ako-si-vybrat-akrylove-farby-podla-viskozity": "how-to-choose-acrylic-paints-by-viscosity",
 "ako-si-vybrat-spravnu-velkost-stetca": "how-to-choose-the-right-brush-size",
 "preco-malovat-akrylom": "5-reasons-to-paint-with-acrylic-paints-instead-of-oil-paints",
 "spravne-platno-pre-mna": "how-to-choose-a-canvas",
 "tipy-pre-umelecky-atelier": "6-tips-for-a-studio-full-of-harmony-and-freedom",
 "prve-dojmy-akvarelove-farby-white-nights-landscape-set": "don-t-be-afraid-of-watercolor-first-impressions-of-white-nig",
 "ako-si-vybrat-spravny-akvarelovy-papier": "how-to-choose-the-right-watercolor-paper",
 "svetlostalost": "how-to-improve-the-lightfastness-of-paintings",
 "6-veci-ktere-pomaly-nicia-vase-stetce": "6-things-that-slowly-damage-your-brushes",
 "viete-naozaj-vsetko-o-polynernej-hmote": "polymer-clay-what-it-is-fimo-or-cernit-and-how-to-bake-it",
 "co-viete-o-polynernej-hmote": "what-do-you-know-about-polymer-clay",
 "ako-malovat-spachtlami": "how-to-use-artmie-palette-knives-step-by-step",
 "artmie-spachtle": "artmie-palette-knives",
 "vsetko-o-farbach-na-sklo": "everything-you-need-to-know-about-glass-paints",
 "je-potrebne-lakovanie-obrazov": "do-you-need-to-varnish-a-painting",
 "alginate-modelovacia-hmota": "alginate-the-modeling-clay-everyone-is-looking-for",
 "mytus-alebo-pravda-je-lakovanie-obrazu-povinne": "myth-or-fact-is-varnishing-a-painting-necessary",
 "vecna-dilema-terpentin-alebo-lanovy-olej": "an-age-old-dilemma-turpentine-or-linseed-oil",
 "co-hovoria-znacky-na-tubach-farieb-na-malovanie": "what-do-the-marks-on-paint-tubes-tell-you",
 "maliarska-dilema-titanova-alebo-zinkova-biela-farba": "painting-dilemma-titanium-white-or-zinc-white-paint",
 "akrylove-kovove-farby-na-zelezne-zabradlia-a-kov-prakticky-navod": "acrylic-metallic-paints-for-iron-railings-and-metal-a-practi",
 "pastely-vs-pastelove-farby-aky-je-rozdiel-kompletny-sprievodca": "pastels-vs-pastel-colors-what-s-the-difference-a-complete-gu",
 "ako-vybrat-maliarske-platno-bavlna-vs-lan": "cotton-linen-or-another-canvas-a-complete-buying-guide",
 "5-rozdielov-medzi-olejovymi-a-akrylovymi-farbami": "5-key-differences-between-oil-paints-and-acrylic-paints",
 "ake-maliarske-platno-vybrat-napnute-karton-rolka": "how-to-choose-a-canvas-stretched-on-cardboard-or-in-a-roll",
 "ako-napnut-uvolnene-platno": "how-to-tighten-a-loose-canvas-complete-guide-for-artists",
 "7-pravidiel-pre-jednoduchsie-cistenie-stetcov-od-olejovych-farieb": "7-rules-for-easier-cleaning-of-brushes-used-with-oil-paints",
 "hahnem-hle-akvarelovy-papier-100-bavlna-kompletny-sprievodca": "hahnemuhle-100-cotton-watercolor-paper-complete-guide",
 "5-menej-obvyklych-podkladov-na-malovanie-a-dekupaz": "5-less-common-surfaces-for-painting-and-decoupage",
 "5-najcastejsich-mytov-o-olejovych-farbach": "5-most-common-myths-about-oil-paints",
 "akrylove-media-su-nevyhnutne-alebo-nie": "acrylic-mediums-are-they-essential-or-not",
 "chameleon-fixky-nieco-uplne-nove": "chameleon-pens-something-completely-new",
 "skusali-ste-uz-malovat-na-platnovy-papier": "have-you-tried-painting-on-canvas-paper",
 "skusali-ste-uz-drevo-ako-podklad-na-malovanie": "have-you-tried-painting-on-wood",
 "mytus-alebo-pravda-nakolko-su-olejove-farby-skutocne-toxicke": "myth-or-fact-how-toxic-are-oil-paints-really",
 "co-su-to-promarkery-a-ako-ich-mozeme-kreativne-vyuzit": "what-are-promarkers-and-how-can-we-use-them-creatively",
 "preco-vsetci-tak-velmi-chvalia-farby-na-kozu-leather": "why-does-everyone-rave-about-leather-paints",
 "cena-akrylovych-farieb-za-liter": "how-much-do-acrylic-paints-cost-per-liter-price-comparison",
 "jednoduchy-diy-navod-na-zivicove-privesky-vyrob-si-trblietave-darceky-doma": "simple-diy-guide-to-resin-pendants-make-glitter-gifts-at-hom",
 "ako-vytvorit-elegantne-reliefne-umenie-z-penovej-dosky-na-platne-navod-krok-za-krokom": "how-to-create-elegant-relief-art-on-canvas-using-foam-board",
 "ako-si-doma-vyrobit-batikovanu-tasku-jednoduchy-navod-pre-kazdeho": "how-to-make-a-tie-dye-bag-at-home-an-easy-guide-for-everyone",
 "vianocne-dekoracie-vyrobene-doma-5-tipov-na-originalne-vianocne-dekoracie": "5-tips-for-original-christmas-decorations",
 "vianocne-ozdoby-z-papiera-kreativne-a-ekologicke-sviatocne-dekoracie": "christmas-paper-ornaments-creative-and-eco-friendly-holiday",
 "7-tvorivych-aktivit-na-dlhe-vecery": "dark-outside-these-7-activities-will-make-long-evenings-more",
 "5-tipov-na-jesenne-tvorenie": "5-tips-for-autumn-crafting",
 "servitkova-technika-co-je-dekupaz-a-ako-sa-robi": "napkin-decoupage-what-is-decoupage-and-how-do-you-do-it",
 "malovana-kabelka-krok-za-krokom": "painted-handbag-step-by-step",
 "vymaluj-si-tekvicu-1": "how-to-paint-a-pumpkin-using-the-zentangle-technique",
 "ako-si-vytvorit-moderne-nausnice-s-polymerovej-hmoty": "how-to-make-modern-polymer-clay-earrings",
 "pexeso-z-platna": "what-to-do-with-a-torn-canvas-make-a-creative-matching-game",
 "handmade-dekorativne-sviecky-vyrob-si": "make-your-own-decorative-candles-with-plants",
 "podlahni-scrapbookingu-1": "the-secrets-of-scrapbooking-how-to-create-works-of-art-from",
 "voskove-obrusky-na-potraviny-vyrob-si": "make-your-own-wax-food-wraps",
 "ako-pouzit-washi-pasky-artmie": "8-ways-to-use-washi-tape-artmie",
 "relaxacne-omalovanky-pre-dospelych-sablony-vo-vnutri": "relaxing-coloring-pages-for-adults-just-print-and-color",
 "domace-vonave-mydlo-vyrob-si": "make-your-own-homemade-scented-soap",
 "makrame-dekoracia-zo-spagatu-vyrob-si": "make-your-own-macrame-cord-decoration",
 "obraz-z-klicekov-a-bavlnky-drevena-dekoracia": "nail-and-thread-art-create-an-original-decoration",
 "vyrob-si-kvety-z-krepoveho-papiera": "make-your-own-crepe-paper-flowers",
 "ako-zacat-so-scrapbookingom": "how-to-get-started-with-scrapbooking",
 "vyrob-si-velkonocne-vajicko-zdobene-zlatom-2022": "make-your-own-easter-egg-decorated-with-gold-2022",
 "vyrob-si-velkonocne-vajicka-s-trblietkami": "make-your-own-easter-eggs-with-glitter",
 "vyrob-si-velkonocne-vajicka-zdobene-susenymi-kvetmi": "make-your-own-easter-eggs-decorated-with-dried-flowers",
 "vyrob-si-velkonocne-vajicko-s-prekvapenim": "make-your-own-easter-egg-with-a-surprise",
 "vyrob-si-hackovane-velkonocne-vajicka": "diy-crochet-easter-eggs",
 "3-napady-na-velkonocne-tvorenie-2022": "3-easter-crafting-ideas-2022",
 "vyrob-si-budka-pre-vtaciky": "make-it-birdhouse",
 "handmade-taska-z-umelej-koze": "make-your-own-handmade-faux-leather-bag",
 "vyrob-si-ekologicka-nakupna-taska": "make-your-own-eco-friendly-shopping-bag",
 "ako-vytvorit-dekoracie-na-halloween": "how-to-create-halloween-decorations",
 "vytvorme-si-krasnu-dekoraciu-na-halloween": "create-a-beautiful-halloween-decoration",
 "ako-si-vytvorit-sviecku-so-stojanom": "how-to-make-a-candle-with-an-easel",
 "stante-sa-hviezdou-halloweenskeho-vecierka-s-farbami-snazaroo": "shine-at-the-halloween-party-with-snazaroo-face-paints",
 "malovanie-podla-cisel-je-zabava": "try-this-year-s-hit-paint-by-numbers",
 "ako-na-originalny-kuchynsky-riad": "how-to-create-original-tableware",
 "vytvor-si-velkonocne-dekoracie": "how-to-make-simple-but-striking-easter-decorations",
 "co-tvorit-pocas-karanteny": "what-to-do-at-home-during-quarantine-we-have-ideas-for-at-ho",
 "napinacie-listy-ram": "make-your-own-silk-painting-frame-from-stretcher-bars",
 "ako-malovat-na-sklenenu-vazu": "how-to-paint-a-glass-vase",
 "malovanie-na-sklo-vianoce": "magical-glass-painting-trends",
 "ako-vyrobit-keramicke-hrnceky-modelarska-hlina-mramorovanie": "make-your-own-ceramic-mugs-with-a-drippy-rainbow-glaze",
 "jarny-vidiecky-veniec": "make-your-own-rustic-style-spring-wreath",
 "ked-stromy-hovoria-navod-na-malovane-dekoracie-z-dreva": "when-trees-speak-a-guide-to-painted-wooden-decorations",
 "batikovanie": "tie-dyeing-step-by-step-guide-to-tying-dyeing-and-setting",
 "scrapbooking-napady-a-priklady": "scrapbooking-ideas-and-examples",
 "diy-drevena-dekoracia-navod-na-tvorenie-s-klincami": "diy-wooden-decor-nail-and-thread-crafting-tutorial",
 "kreativne-tipy-na-dekoracie-s-tekvicou-pouzite-drevene-ozdoby-a-temperove-farby": "creative-pumpkin-decorating-ideas-use-wooden-ornaments-and-t",
 "par-zaujimavych-faktov-o-dekupazi-o-ktorych-ste-nevedeli": "a-few-interesting-facts-about-decoupage-you-didn-t-know",
 "niekolko-super-zaujimavosti-o-decoupage-technike-ktore-nepoznate": "a-few-super-interesting-facts-about-the-decoupage-technique",
 "decoupage-na-skle-navod": "decoupage-on-glass-a-complete-guide-to-creating-original-dec",
 "decoupage-na-drevo-navod": "decoupage-on-wood-complete-guide-to-preparation-gluing-and-v",
 "umenie-origami-papier-skladanie-projekty": "the-art-of-origami-a-complete-guide-to-paper-folding-for-beg",
 "najlepsi-online-obchod-so-scrapbookingom-co-sa-oplati-vybrat": "the-best-online-scrapbooking-store-what-to-look-for",
 "vzdy-ta-zaujimala-mozaika-toto-je-text-pre-teba": "have-you-always-been-curious-about-mosaics-this-is-for-you",
 "co-vyrobit-zo-samotvrdnucej-hmoty": "what-to-make-with-air-dry-clay-12-ideas-for-kids-and-adults",
 "krakelovanie-postup": "crackle-step-by-step-guide-with-varnish-medium-and-paste",
 "farebne-akordy-v-umeni-hra-s-harmoniou-na-tvojej-palete": "color-chords-in-art-playing-with-harmony-on-your-palette",
 "co-keby-si-si-zacala-pisat-dennik-prave-teraz": "what-if-you-started-keeping-a-journal-right-now",
 "vytvor-kreativny-odkaz-pre-svoje-buduce-ja": "create-a-creative-message-for-your-future-self",
 "valentinska-inspiracia-pre-kazdeho-tvorivca": "valentine-s-day-inspiration-for-every-creative",
 "miesanie-farieb-ukazeme-ti-ako-na-to": "mixing-colors-we-ll-show-you-how",
 "galeria-umelcov-rozhovor-s-barborou-sebes": "an-interview-with-artist-and-doctor-barbora-sebes",
 "zazi-euforiu-pri-tvorbe-svojho-diela": "experience-euphoria-as-you-create-your-artwork",
 "vieme-co-darovat-na-vianoce": "8-gift-ideas-for-an-artist",
 "tajny-jazyk-malby": "the-secret-language-of-painting-how-to-read-a-work-of-art",
 "objav-najlepsie-farebne-komba-v-malovani": "discover-the-best-color-combinations-in-painting",
 "farba-mesiaca-maj-svetloruzova": "color-of-the-month-for-may-light-pink",
 "farba-mesiaca-april-voskova-zlta": "color-of-the-month-wax-yellow-april-2022",
 "kviz-o-akvarelovych-farbach": "watercolor-quiz",
 "farba-mesiaca-marec-oranzova": "color-of-the-month-march-orange",
 "farba-mesiaca-februar-ladova-matova": "color-of-the-month-icy-mint",
 "co-na-valentina-5-filmov-s-umeleckym-nadychom": "what-to-watch-on-valentine-s-day-5-art-inspired-movies-you-h",
 "farba-mesiaca-januar-indigo": "color-of-the-month-january-indigo",
 "pozname-farbu-na-rok-2022": "we-know-the-color-of-the-year-2022",
 "terminy-z-umeleckeho-sveta-ktore-ti-rozsiria-obzory": "art-terms-that-will-broaden-your-horizons",
 "10-filmov-o-umelcoch-ktore-musis-vidiet": "10-movies-about-artists-you-have-to-see",
 "bodka-za-letom-oceanova-modra": "a-final-note-of-summer-ocean-blue",
 "farba-mesiaca-zlata": "july-s-color-of-the-month-gold",
 "v-sulade-s-prirodou-umenie-ekologicky-a-tvorivo": "art-in-harmony-with-nature-create-sustainably-and-creatively",
 "farby-na-rok-2021-sk": "colors-for-2021",
 "tipy-na-mesta-ktore-v-tebe-prebudia-kreativitu": "not-sure-what-to-paint-these-cities-will-spark-your-creativi",
 "poraz-nudu-tvorenim": "crafting-relieves-stress-help-yourself-and-your-family-feel",
 "ako-zlepsit-svoje-umelecke-zrucnosti-10-tipov": "how-to-improve-your-artistic-skills-10-tips",
 "s-cim-maluje-gerhard-richter": "oil-paints-and-gerhard-richter-s-secret-to-success",
 "malovanie-podla-cisel-trend": "where-did-paint-by-numbers-come-from",
 "co-darovat-zene-na-mdz": "what-to-give-a-woman-for-international-women-s-day",
 "farba-roka-2019-ako-ju-kombinovat": "color-of-the-year-2019-on-canvas-and-sneakers",
 "dovody-preco-randit-s-umelcom": "6-reasons-to-date-an-artist",
 "vianocne-tipy-na-darcek-pre-umelca": "christmas-is-coming-what-to-get-an-artist",
 "co-je-freska": "what-is-a-fresco",
 "oranzova-farba-akrylova-akvarelova-olejova": "orange-a-color-not-to-be-underestimated",
 "exterierove-farby-streetart": "what-caught-our-eye-pop-art-uncovered-after-30-years",
 "sietotlac-a-andy-warhol": "the-secrets-of-andy-warhol-s-art",
 "rasto-ekkert-ako-zacat": "rasto-ekkert-beginnings-are-hard-but-finding-your-own-path-i",
 "co-je-to-grafika": "what-is-printmaking",
 "umelecka-mapa": "art-map-of-europe-do-you-know-which-artist-represents-slovak",
 "ako-sa-odhaluje-zahadna-dama-v-cervenom": "the-charm-of-restoration",
 "prekrasne-sklenene-plastiky-v-kmenoch-stromov": "beautiful-glass-sculptures-in-tree-trunks",
 "uhadni-cim-kreslim": "guess-what-i-m-drawing",
 "vedci-vynasli-novy-odtien-modrej-vies-ako-sa-vola": "scientists-invented-a-new-shade-of-blue-do-you-know-its-name",
 "unikatna-snimka-olejomalby-z-filmu-loving-vincent": "a-unique-oil-painting-still-from-loving-vincent",
 "efekt-hrdze-kreativna-tvorba": "m-rust-effect-once-unwanted-now-a-welcome-element-in-creativ",
 "najznamensite-diela-pabla-picassa": "the-most-famous-works-of-pablo-picasso",
 "co-je-to-operacia-nocna-hliadka-a-preco-je-dolezita": "what-is-operation-night-watch-and-why-is-it-important",
 "efekt-hrdze-kedysi-neziaduci-teraz-vitany": "rust-effect-once-unwanted-now-welcome",
 "eaa-2021-rozhovor-s-porotou-bulharsko": "eaa-2021-interview-with-the-jury-bulgaria",
 "najdrahsie-obrazy-na-svete": "most-expensive-paintings-in-the-world",
 "5-tipov-ako-urobit-tvoj-obraz-bohatsim": "5-tips-to-make-your-painting-richer",
 "tvorba-umenia-z-roztaveneho-skla-a-dreva-unikatne-umenie-slagermana-a-fishmana": "creating-art-from-molten-glass-and-wood-unique-art-by-slager",
 "muzeum-pigmentov-harvard-umenie": "did-you-know-there-s-a-museum-of-pigments",
 "milica-bjelanovic-vasen-ktora-ozivuje-grafiku": "milica-bjelanovic-a-passion-that-brings-printmaking-to-life",
 "umelecka-kolonia-vranje-2018-oficialne-otvorena": "vranje-2018-art-colony-officially-opens",
 "eaa-2021-rozhovor-s-porotou-severne-macedonsko": "eaa-2021-interview-with-the-jury-north-macedonia",
 "ako-sa-odhaluje-zahadna-dama-v-cervenej": "how-the-mysterious-lady-in-red-is-revealed",
 "neda-laketic-soc-socharka-vynimocneho-maliarskeho-nadsenia-a-umenia": "neda-laketic-soc-a-sculptor-with-an-exceptional-passion-for",
 "dunja-sirmium-mozaikarka-vynimocnej-maliarskej-techniky": "dunja-sirmium-mosaic-artist-with-an-exceptional-painting-tec",
 "rozhovor-s-porotou-eaa-2021-bulharsko": "interview-with-the-eaa-2021-jury-bulgaria",
 "dubajska-cokolada-iluzia-ktoru-chces-ochutnat-aj-ty": "dubai-chocolate-an-illusion-you-ll-want-to-taste-too",
 "teoria-farieb-a-farebny-kruh-pre-umelcov": "color-theory-and-the-color-wheel-a-complete-guide-for-every",
 "farba-roka-archiv-trendy-vo-farbach": "color-of-the-year-a-complete-guide-to-trends-color-theory-an",
 "kolko-toho-v-skutocnosti-viete-o-nastennych-malbach": "how-much-do-you-really-know-about-murals",
 "najdene-2-nove-rafaelove-obrazy": "2-new-raphael-paintings-discovered",
 "bezpecne-farebne-a-zabavne-preco-su-netoxicke-prstove-farby-mucki-idealne-pre-deti": "safe-colorful-and-fun-why-mucki-non-toxic-finger-paints-are",
 "objav-sensory-art-so-sadami-okto": "discover-sensory-art-with-okto-sets",
 "detska-izba-snov-ako-vytvorit-detom-miesto-na-hranie-a-tvorivu-zabavu": "a-dream-kids-room-how-to-create-a-place-for-kids-to-play-and",
 "tipy-na-tvorive-darceky-pre-deti": "creative-gift-ideas-for-kids",
 "malovanie-na-kamene-s-detmi-zabav-pocas-leta": "painting-rocks-with-kids-cheerful-and-colorful-rocks",
 "malovanie-s-detmi-kamene-ako-velkonocne-vajicka": "painting-with-kids-rocks-like-easter-eggs",
 "zabavte-sa-s-detmi-s-tekutymi-farbami-na-chodnik": "enjoy-summer-with-sidewalk-chalk-paints-for-kids",
 "ako-zvladnut-karantenu-s-detmi-5-tipov": "5-tips-for-getting-through-quarantine-at-home-with-kids",
 "deti-doma-kvoli-karantene-kreativne-ich-zabavte": "kids-stuck-at-home-due-to-the-coronavirus-quarantine-we-know",
 "malovanie-s-detmi": "painting-with-kids-and-creative-christmas-crafts",
 "hura-do-skoly-maliarske-potreby-pre-malych-aj-velkych": "back-to-school-art-supplies-for-kids-and-adults",
 "malovanie-podla-cisel-pre-deti-ako-vybrat-tu-spravnu-sadu": "paint-by-numbers-for-kids-how-to-choose-the-right-set",
 "tvorive-aktivity-doma-sprievodca-pre-rodiny": "creative-projects-at-home-a-complete-art-guide-for-everyone",
 "farby-mucki-pre-deti-kompletny-sprievodca-prstove-na-okna-outdoor": "mucki-paints-for-kids-a-complete-guide-finger-paints-window",
 "artmiesk-je-vitazom-shoproku-2024-dakujeme-ze-ste-pri-nas": "we-won-shoproku-2024-and-it-s-thanks-to-you",
 "vyhodnotenie-artmie-contest-2024": "artmie-contest-2024-results-an-explosion-of-creativity-and-t",
 "artmie-contest-2024-1": "artmie-contest-art-competition-for-art-school-students",
 "artmie-novinky-2024": "2024-is-full-of-new-artmie-products-which-ones-will-we-welco",
 "utajeny-sef-vali-to-prestrelil-doslova-ako-si-poradil-s-pracou-v-artmie": "undercover-boss-vali-went-too-far-literally-how-did-he-handl",
 "shoproku2022": "the-shoproku-contest-is-here-do-we-deserve-to-win-again",
 "inktober-artmie-2022": "join-inktober-with-artmie",
 "ako-dopadol-artmie-inktober-2021": "how-did-artmie-inktober-2021-go",
 "posledny-tyzden-artmie-inktobra-pred-nami": "artmie-inktober-s-final-week-is-here",
 "artmie-inktober-temy-pocas-stvrteho-tyzdna": "artmie-inktober-prompts-for-week-four",
 "artmie-inktober-co-prinesie-treti-tyzden": "artmie-inktober-what-the-third-week-has-in-store",
 "artmie-inktober-temy-v-druhom-tyzdni": "artmie-inktober-themes-for-the-second-week",
 "artmie-inktober-inspirujeme-vas-aj-seba": "artmie-inktober-inspiring-you-and-ourselves",
 "inktober-vyzva-ktora-spaja-umelcov-po-celom-svete": "inktober-a-challenge-that-brings-artists-together-around-the",
 "sutaz-pre-umelcov-eaa-je-tento-rok-plna-pozitivnej-energie": "the-eaa-artists-competition-is-full-of-positive-energy-this",
 "eaa-2020-v-znameni-prirody": "the-international-eaa-competition-has-begun-submit-your-work",
 "artmie-vitaz-shoproku2019": "we-won-shoproku-2019",
 "plnime-farebne-umelecke-sny": "we-make-colorful-artistic-dreams-come-true",
 "eaa-medzinarodna-sutaz-europska-cena-za-umenie": "european-art-award-complete-guide-to-the-international-art-c",
 "ocenenia-a-uznania-artmie-shoproku-archiv": "artmie-and-prestigious-awards-why-shoproku-and-other-titles",
 "artmie-contest-rocna-sutaz-pre-studentov-umenia": "artmie-contest-complete-guide-to-the-annual-art-competition",
 "odpovedame-na-5-viac-nez-zaujimavych-otazok": "we-answer-5-truly-interesting-questions"
};
  var COLLECTION_HANDLES_IE = {
 "novinky": "novelties",
 "400-tipov-na-darcek": "400-gift-ideas",
 "specialna-ponuka": "special-offer",
 "bestsellery": "bestsellers",
 "svadba": "wedding",
 "vianoce": "christmas",
 "valentin": "st-valentine-s-day",
 "velka-noc": "easter",
 "darcekove-poukazy": "gift-vouchers",
 "malovanie-podla-cisel": "paint-by-numbers-kits",
 "pre-deti": "kids",
 "pre-zaciatocnikov": "for-beginners",
 "pre-stredne-pokrocilych": "for-intermediate-painters",
 "pre-pokrocilych": "advanced-paint-by-numbers",
 "malovanie-podla-cisel-z-fotky": "paint-by-numbers-from-a-photo",
 "umelecke-potreby": "art-supplies",
 "maliarske-platna": "painting-canvases",
 "maliarske-platno-na-rame": "stretched-canvas",
 "maliarske-platno-eco": "eco-canvas",
 "specialne-maliarske-platno": "special-painting-canvas",
 "platno-na-lepenke": "canvas-board",
 "platno-na-rolke-metraz": "canvas-by-the-meter-roll-canvas",
 "listy-ramy-prislusenstvo": "stretcher-bars-and-stretcher-frames",
 "vyroba-reprodukcii": "art-reproductions",
 "maliarske-stojany": "easels",
 "maliarske-stojany-stolove": "tabletop-easels",
 "maliarske-stojany-atelierove": "studio-easels",
 "polne-stojany-exterierove": "field-easels-for-outdoor-use",
 "dosky-na-stojan": "boards-for-easels",
 "stetce": "brushes",
 "sady-stetcov": "brush-sets",
 "gulate-stetce": "round-brushes",
 "ploche-stetce": "flat-brushes",
 "stetce-na-podklad-a-sepsovanie": "brushes-for-surface-preparation-and-gesso-priming",
 "spachtle-a-maliarske-noze": "spatulas-and-painter-s-knives",
 "stetce-na-nechty-a-make-up": "nail-and-makeup-brushes",
 "palety-a-pomocky": "palettes-and-tools",
 "maliarske-palety": "painting-palettes",
 "nadobky-na-miesanie-farieb": "containers-for-mixing-colors",
 "dalsie-pomocky": "other-tools",
 "papiere-a-vykresy": "paper",
 "bloky-papierov-vykresy": "paper-pads-drawing-paper",
 "ramy-pasparty": "frames-mats",
 "baliaci-material-pre-umelcov": "packaging-material-for-artists",
 "zapisniky-diare": "notebooks-diaries",
 "farby-a-pripravky": "paints-and-mediums",
 "akrylove-farby": "acrylic-paints",
 "akryl-pre-umelcov": "acrylic-colors-for-artists",
 "sady-akrylovych-farieb": "acrylic-paint-sets",
 "hobby-akryl": "hobby-acrylic",
 "pripravky-pre-akryl": "acrylic-agents",
 "akrylove-fixy": "acrylic-markers",
 "olejove-farby": "oil-paints",
 "olejove-farby-pre-umelcov": "oil-paints-for-artists",
 "sady-olejovych-farieb": "oil-paint-sets",
 "pripravky-pre-olejomalbu": "oil-painting-agents",
 "akvarelove-farby": "watercolors-for-artists",
 "gvasove-a-temperove-farby": "tempera-and-gouache-paints",
 "airbrush": "airbrush-supplies",
 "hobby-farby": "hobby-paints",
 "exterierove-farby": "exterior-paints",
 "farby-na-textil": "fabric-paints",
 "farby-na-sklo": "glass-paints",
 "farby-na-keramiku": "ceramic-paints",
 "farby-na-hodvab": "silk-paints",
 "farby-na-tvar": "face-paints",
 "farba-graficka": "graphic-paint",
 "farby-v-spreji-a-fixky": "spray-paints-and-markers",
 "atrament-a-tuse": "ink-and-drawing-inks",
 "pripravky-pre-malbu": "painting-agents",
 "finalne-zaverecne-pripravky": "finalfixing-agents",
 "pripravky-pre-podklad": "priming-agents",
 "pripravky-pre-olejomalbu-1": "mediums-and-varnishes-for-oil-painting",
 "media-pre-akryl": "acrylic-mediums",
 "efektove-pasty-a-gely": "effect-pastes-and-gels",
 "kreativne-potreby": "craft-supplies",
 "hobby-potreby": "hobby-products",
 "dekupaz-servitkovanie": "decoupage-napkin-decoupage",
 "malovanie-na-textil": "fabric-painting",
 "malovanie-na-sklo": "painting-on-glass-and-porcelain",
 "malovanie-na-keramiku": "painting-on-ceramics",
 "malovanie-na-hodvab": "painting-on-silk",
 "pletenie-hackovanie-vysivanie": "knitting-crocheting-embroidery",
 "modelovanie": "modeling-clay",
 "kaligrafia": "calligraphy",
 "linoryt-graficka-technika": "linocut-printmaking-technique",
 "pozlacovanie-a-patinovanie": "gilding-and-patina",
 "vyroba-mydla-a-sviecok": "soaps-and-candles",
 "zivica-odlievanie": "epoxy-resin-for-casting",
 "vyroba-sperkov": "jewelry-making",
 "mramorovanie": "marbling",
 "svadobne-dekoracie": "wedding-decorations",
 "malovanie-na-tvar": "face-painting",
 "filcovanie-plstenie": "felting",
 "malovanie-podla-cisel-1": "paint-by-numbers",
 "skrabacie-obrazky": "scratch-paintings",
 "kreativne-komponenty": "creative-components",
 "drevo": "wood",
 "polystyren": "polystyrene",
 "textil-a-hodvab": "fabric-and-silk",
 "stuhy-girlandy-organzy": "ribbons-garlands-organza",
 "filtre-glitre-pierka": "sequins-glitter-feathers",
 "dekoracny-material": "decorative-material",
 "sablony-na-malovanie": "painting-stencils",
 "polymerove-hmoty": "polymer-clay",
 "kontury": "contours",
 "peciatky": "stamps",
 "hobby-lepidla": "hobby-glues",
 "prutie-a-supolie": "wicker-and-scales",
 "nastroje": "tools",
 "rozne-pomocky": "various-tools",
 "kreativne-potreby-pre-deti": "craft-supplies-for-kids",
 "hracky-pre-deti": "creative-toys",
 "handmade-byvanie": "handmade-living",
 "kreslenie": "drawing-art-supplies",
 "ceruzky-a-uhliky": "pencils-and-charcoals",
 "farbicky": "colored-pencils-for-drawing",
 "markery-fixy": "markers-felt-tip-pens",
 "pastely": "art-pastels-for-drawing",
 "olejove-pastely": "oil-pastels",
 "suche-pastely": "soft-pastels",
 "voskove-pastely": "wax-crayons",
 "kaligrafia-a-hand-lettering": "hand-lettering-and-brush-pens",
 "skicovacie-bloky": "sketchbook",
 "technicke-kreslenie": "technical-drawing",
 "technicke-pera-a-ceruzky": "technical-pens-and-pencils",
 "technicke-pravitka-a-sablony": "technical-rulers-and-templates",
 "papier-pauzovaci-a-milimetrovy": "tracing-and-graph-paper",
 "dosky-na-rysovanie": "drawing-boards",
 "tubusy-a-tasky-na-vykresy": "tubes-and-bags-for-drawing-paper",
 "nase-znacky": "our-brands",
 "knihy-a-inspiracie": "books-and-coloring-books",
 "knihy-kreslenie-a-malovanie": "drawing-and-painting-books",
 "skolske-potreby": "school-supplies",
 "kreativne-sety": "creative-sets",
 "servitky-papiere-na-decoupage": "napkins-and-papers-for-decoupage",
 "laky-a-lepidla-na-decoupage": "decoupage-glues-and-varnishes",
 "komponenty-pre-decoupage": "components-for-decoupage",
 "dalsie-pomocky-pre-decoupage": "other-decoupage-supplies",
 "okruhle-platno": "round-canvas",
 "zlava": "sale",
 "maliarske-platno-profi": "profi-canvas",
 "modelovanie-a-odlievanie": "modeling-and-casting",
 "malovanie-na-povrchy": "painting-on-surfaces",
 "textil-a-rucne-prace": "textiles-and-handicrafts",
 "papier-scrapbook-dekupaz": "paper-scrapbooking-and-decoupage",
 "dekoracny-material-skupina": "decorative-materials",
 "kreativne-pre-deti-skupina": "craft-supplies-for-kids-2",
 "sezonne-tvorenie": "seasonal-crafting",
 "nastroje-a-lepidla": "tools-and-glue",
 "kreativne-sady-a-sety": "creative-kits-and-sets",
 "umelecke-farby": "artist-paints",
 "farby-na-povrchy": "surface-paints",
 "pripravky-a-laky": "mediums-and-varnishes",
 "papiere-a-bloky": "paper-and-paper-pads",
 "ramy-a-prislusenstvo": "frames-and-accessories",
 "ceruzky-a-grafika": "pencils-and-printmaking",
 "pastely-a-fixy": "pastels-and-markers",
 "papiere-a-pomocky-kreslenie": "paper-and-drawing-supplies",
 "maliarske-stojany-vsetky-typy": "easels-all-types",
 "umelecke-stetce-a-pomocky": "art-brushes-and-supplies",
 "kreslarske-potreby": "drawing-supplies",
 "homepage-curated": "our-top-picks",
 "bestseller-sk": "best-sellers",
 "bestseller-si": "bestsellers-2",
 "bestseller-hr": "best-sellers-2",
 "bestseller-it": "bestsellers-3",
 "bestseller-gr": "best-sellers-3",
 "homepage-curated-bg": "we-recommend-top-picks-bg",
 "amh-bestsellers": "artmie-bestsellers",
 "zostav-si-vlastny-set": "build-your-own-set",
 "zvyhodnene-sety": "discounted-sets",
 "farby-na-kozu": "leather-paints",
 "lanove-maliarske-platna": "linen-canvas",
 "maliarske-platna-pre-deti": "painting-canvases-for-kids-and-schools",
 "obrazy-od-umelcov": "paintings-by-artists",
 "fixky-na-textil": "fabric-markers",
 "samotvrdnuca-modelovacia-hmota": "air-dry-modeling-clay",
 "fixky-na-sklo-a-porcelan": "glass-and-porcelain-markers",
 "plastelina": "modeling-clay-2",
 "silikonove-formy-na-zivicu": "silicone-molds-for-resin"
};
  function rewriteLocalizedHandles() {
    try {
      var anchors = document.querySelectorAll('a[href]');
      for (var i = 0; i < anchors.length; i++) {
        var a = anchors[i];
        var h = a.getAttribute('href');
        if (!h || h.charAt(0) === '#') continue;
        /* Normalize: strip origin if same-host, retain path */
        var p = h;
        if (/^https?:/i.test(h)) {
          try { var u = new URL(h, window.location.origin); if (u.host !== window.location.host) continue; p = u.pathname + u.search + u.hash; } catch (e) { continue; }
        }
        if (p.charAt(0) !== '/') continue;
        /* Match /<locale-prefix>?/(pages|collections|blogs)/<slug>(/<article>)? */
        var m = p.match(/^(\/(?:en-ie)\/)?(pages|collections|blogs)\/([^\/?#]+)(\/([^\/?#]+))?(.*)$/);
        if (!m) continue;
        var prefix = m[1] || '/';
        var type = m[2];
        var slug = m[3];
        var subSlug = m[5];
        var rest = m[6] || '';
        var newSlug = slug, newSub = subSlug;
        if (type === 'pages') {
          if (PAGE_HANDLES_IE[slug]) newSlug = PAGE_HANDLES_IE[slug];
        } else if (type === 'collections') {
          if (COLLECTION_HANDLES_IE[slug]) newSlug = COLLECTION_HANDLES_IE[slug];
        } else if (type === 'blogs') {
          if (BLOG_HANDLES_IE[slug]) newSlug = BLOG_HANDLES_IE[slug];
          if (subSlug && ARTICLE_HANDLES_IE[subSlug]) newSub = ARTICLE_HANDLES_IE[subSlug];
        }
        if (newSlug === slug && newSub === subSlug) continue;
        var newP = prefix + type + '/' + newSlug + (newSub ? '/' + newSub : '') + rest;
        a.setAttribute('href', newP);
      }
    } catch (e) {}
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', rewriteLocalizedHandles);
  else rewriteLocalizedHandles();
  setTimeout(rewriteLocalizedHandles, 500);
  setTimeout(rewriteLocalizedHandles, 1500);
  setTimeout(rewriteLocalizedHandles, 3000);
  /* MutationObserver for lazy-loaded content */
  try { if (window.MutationObserver) { new MutationObserver(function () { rewriteLocalizedHandles(); }).observe(document.documentElement, { childList: true, subtree: true }); } } catch (e) {}
  /* === phase-67-end === */

})();

